<template>
    <div id="ContractAssetView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="web-right-sidebar">
            <div class="right-asset-tab-list">
                <ul class="activetabs" id="tabActive">
                    <li v-bind:class="[ activetab === 1 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=1" >Contract Asset Detail</a></li>
                    <li v-bind:class="[ activetab === 3 ? 'active' : '' ]" id="contract_rate_tab"> <a href="javascript:void(0)" v-on:click="activetab=3">Contract Rates</a></li>
                    <li v-bind:class="[ activetab === 6 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=6 , returnFlag = false">Reading</a></li>
                    <li v-bind:class="[ activetab === 2 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="cpiRateHistoryClicked()">Rate History</a></li>
                    <li v-bind:class="[ activetab === 4 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=4;billingRecords()">Billing Records</a></li>
                    <li v-bind:class="[ activetab === 5 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=5">Allowance</a></li>
                    <li v-bind:class="[ activetab === 7 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab = 7"> License Details </a> </li>
                    <li v-bind:class="[ activetab === 8 ? 'active' : '' ]"> <a v-on:click="activetab=8;fetchInsurancePolicy()">Insurance Policy</a></li>
                    <li v-bind:class="[ activetab === 9 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab = 9"> Miscellaneous Charges </a> </li>
                    <li v-bind:class="[ activetab === 10 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="getCustomerInvoice()"> Invoices </a> </li>
                    <li v-bind:class="[ activetab === 11 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="getActivityLog()"> Activity Log </a> </li>
                </ul>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name">
                    <div class="page-title"> Contract Asset View | {{contractAssetData.vmUnitNo}}</div>
                    <clear-cache-data :pageKey="[pageKey,subKey1,subKey2]" ></clear-cache-data>

                    <div class="web-action-btn btn-groups text-right">

                        <!--router-link v-if="isRefInq" class="btn btn-secondary" v-on:click.prevent="goPreviousPath" > <i class="fp-back"></i> Back</router-link-->
                        <button v-if="isRefInq" type="submit" class="btn btn-secondary" v-on:click.prevent="goPreviousPath"><i class="fp-back"> </i> Back</button>
                        <router-link v-if="canListConAsset && !isRefInq" class="btn btn-secondary" v-bind:to="{name: 'ContractAssetDetailList'}" > <i class="fp-back"></i> Back</router-link>
                        <router-link v-if="closed == 0 && canUpdateConAsset && contractAssetData.status == 'pending'" title="Edit Asset" class="btn btn-primary"
                                v-bind:to="{name: 'ContractAssetDetailEdit',params:{id:$route.params.id},query:{fromUrl:fromUrl}}">
                                <i class="fp-edit-icon"> </i> Edit
                        </router-link>
                        <!-- <router-link v-if="closed == 1  && canUpdateConAsset && contractAssetData.status == 'closed'" title="Edit Asset" class="btn btn-primary"
                                v-bind:to="{name: 'ContractAssetDetailEdit',params:{id:$route.params.id},query:{from:'return'}}">
                                <i class="fp-edit-icon"> </i> Edit
                        </router-link> -->
                        <button v-if="contractAssetData.status == 'pending' && canUpdateConAsset && closed == 0" type="submit" class="btn btn-secondary" v-on:click.prevent="checkTriggers('')">Process</button>
                        <button v-if="canUpdateConAsset" type="submit" class="btn btn-secondary" v-on:click.prevent="rebillVariable">Rebill</button>
                        <button v-if="closed == 0 && canUpdateConAsset && contractAssetData.status == 'active' && alreadyBilled == 'no'" type="submit" class="btn btn-secondary" v-on:click.prevent="openModal('first')">Post Invoice</button>
                        <button v-if="closed == 1 && canUpdateConAsset" type="submit" class="btn btn-secondary" v-on:click.prevent="openModal('last')">Post Invoice</button>
                        <button v-if="closed == 0 && canUpdateConAsset && contractAssetData.status == 'active'" type="submit" class="btn btn-secondary" v-on:click.prevent="returnContractAsset()">Return</button>

                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <router-link v-if="isRefInq" class="btn btn-secondary" v-on:click.prevent="goPreviousPath" > <i class="fp-back"></i> Back</router-link>

                        <router-link v-if="canListConAsset && !isRefInq" class="btn btn-secondary" v-bind:to="{name: 'ContractAssetDetailList'}"> <i class="fp-back"></i> Back</router-link>
                        <router-link v-if="closed == 0 && canUpdateConAsset && contractAssetData.status == 'pending'" title="Edit Asset" class="btn btn-primary"
                                v-bind:to="{name: 'ContractAssetDetailEdit',params:{id:$route.params.id},query:{fromUrl:fromUrl}}">
                                <i class="fp-edit-icon"> </i> Edit
                        </router-link>
                        <!-- <router-link v-if="closed == 1  && canUpdateConAsset && contractAssetData.status == 'closed'" title="Edit Asset" class="btn btn-primary"
                                v-bind:to="{name: 'ContractAssetDetailEdit',params:{id:$route.params.id},query:{from:'return'}}">
                                <i class="fp-edit-icon"> </i> Edit
                        </router-link> -->
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li>
                                    <a v-if="contractAssetData.status == 'pending' && canUpdateConAsset && closed == 0" v-on:click.prevent="checkTriggers('')">Process</a>
                                </li>
                                <li>
                                    <a v-if="canUpdateConAsset" href="javascript:void(0)" type="submit" class="btn btn-secondary" v-on:click.prevent="rebillVariable">Rebill</a>
                                </li>
                                <li>
                                    <a v-if="closed == 1 && canUpdateConAsset" v-on:click.prevent="openModal('last')">Post Invoice</a>
                                </li>
                                <li>
                                    <a v-if="closed == 0 && canUpdateConAsset && contractAssetData.status == 'active' && alreadyBilled == 'no'" v-on:click.prevent="openModal('first')">Post Invoice</a>
                                </li>
                                <li v-if="canUpdateConAsset && closed == 0 && contractAssetData.status == 'active'">
                                   <a v-on:click.prevent="returnContractAsset()">Return</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content contract-asset-view list-view">
                        <section class="internal-container border-top-table-fl" >
                            <div v-if="activetab === 1" class="list-sections">
                                <div class="form-row no-divider">
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Contract Code:</label>
                                            <span class="col"> {{titleCase(contractAssetData.contName)}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Asset :</label>
                                            <span class="col">
                                                <a href="javascript:void(0)" title="View asset" class="color-blue" v-on:click.prevent="viewModule('asset',vehicle_id)">
                                                    {{contractAssetData.vmUnitNo}} | {{titleCase(contractAssetData.vmName)}}
                                                </a>
                                            </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Customer :</label>
                                            <span class="col">
                                                <a href="javascript:void(0)" title="View customer" class="color-blue" v-on:click.prevent="viewModule('customer',customer_id)">
                                                    {{contractAssetData.cust_code}} | {{contractAssetData.cust_name}}
                                                </a>
                                            </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Effective Date: </label>
                                            <span class="col"> {{titleCase(contractAssetData.effective_date)}} </span>
                                        </div>
                                        <div class="row form-group" v-if="contractAssetData.cpi_waived == 0">
                                            <label class="col"> First Escalation Date: </label>
                                            <span class="col"> {{titleCase(contractAssetData.first_escalation_date)}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Allow Substitute: </label>
                                            <span class="col" v-if="contractAssetData.allow_substitute == 1"> YES </span>
                                            <span class="col" v-else> NO </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Base Index Date: </label>
                                            <span class="col"> {{titleCase(contractAssetData.base_index_date)}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Status: </label>
                                            <span class="col"> {{titleCase(contractAssetData.status)}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Customer Unit: </label>
                                            <span class="col"> {{titleCase(contractAssetData.cust_unit_no)}} </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col"> Contract Type: </label>
                                            <span class="col"> {{titleCase(contractAssetData.ctName)}} ({{contractAssetData.ctCode}}) </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Asset Type: </label>
                                            <span class="col"> {{titleCase(contractAssetData.vtName)}} ({{contractAssetData.vtCode}}) </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Term: </label>
                                            <span class="col"> {{contractAssetData.term}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Expiry Date: </label>
                                            <span class="col"> {{titleCase(contractAssetData.expiry_date)}} </span>
                                        </div>
                                        <div class="row form-group" v-if="contractAssetData.cpi_waived == 0">
                                            <label class="col"> Next Escalation Date: </label>
                                            <span class="col"> {{titleCase(contractAssetData.next_escalation_date)}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Base Index Value: </label>
                                            <span class="col"> {{titleCase(contractAssetData.base_index_value)}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> CPI Waived: </label>
                                            <span class="col" v-if="contractAssetData.cpi_waived == 1"> Yes </span>
                                            <span class="col" v-else> No </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Excess Mileage Variation Allowed(%): </label>
                                            <span class="col"> {{titleCase(contractAssetData.ex_mile_variation)}} </span>

                                        </div>
                                        <div class="row form-group">
                                            <label class="col"> Allow Substitute: </label>
                                            <span class="col" v-if="contractAssetData.allow_substitute == 1"> Yes </span>
                                            <span class="col" v-else> No </span>

                                        </div>
                                        <div class="row form-group">
                                          <label class="col"> Customer Purchase Order: </label>
                                          <div class="col">
                                            <template v-if="editPurchaseOrder">
                                              <span> {{titleCase(contractAssetData.po_no)}} </span>
                                              <button class="btn btn-primary" v-on:click="editPurchaseOrderDropDown()">
                                                <i class="fp-edit-icon"></i>Edit
                                              </button>
                                            </template>
                                            <template v-else>
                                              <div class="form-group">
                                                <v-select v-model="po" name="po"
                                                          label="text" :filterable="false" :options="poArr"
                                                          @search="onSearchPO"
                                                          placeholder="Select PO" class="custom-ci-auto-search col" style="padding-left: 0px">
                                                  <template slot="no-options">
                                                    Search PO...
                                                  </template>
                                                  <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                      {{ option.text }}
                                                    </div>
                                                  </template>
                                                  <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                      {{ option.text }}
                                                    </div>
                                                  </template>
                                                </v-select>
                                                <div class="field-error" id="customererror">{{ customer_po_error_msg }}</div>
                                              </div>
                                              <div class="btn-group">
                                                <button class="btn btn-primary" v-on:click.prevent="savePo()">
                                                  <i class="fp-save"> </i> Save
                                                </button>
                                                <button class="btn btn-tertiary" v-on:click.prevent="cancelPurchaseOrderEdit()">
                                                  <i class="fp-close"> </i> Cancel
                                                </button>
                                              </div>
                                            </template>
                                          </div>
                                        </div>
                                    </div>

                                </div>
                                <section v-if="returnFlag || closed != 0" class="internal-container border-top-table-fl" >
                                    <h5>Return Unit</h5>
                                        <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" style="margin-top:20px;" id="ContractAssetDetailForm">
                                            <div class="form-row row-cols-md-4 row-cols-1">
                                                <div v-if="closed == 0" class="col form-group">
                                                    <label class="control-label require">Termination Date:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="expiry_date" name="expiry_date" v-model="expiry_date" @input="ChangeExpiry(expiry_date)" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                                        <label for="expiry_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <div class="field-error">{{expiry_date_error_msg}}</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="alert alert-warning hide col-sm-6" id="alertError">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong id="errorMsg" class="field-error"></strong>
                                                </div>
                                            </div>
                                            <template>
                                                <h4> Reading Out</h4>
                                                <div class="table-responsive-sm">
                                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                        <thead>
                                                            <tr class="table-primary">
                                                                <th>Section</th>
                                                                <th>Reading Date</th>
                                                                <th>Reading</th>
                                                                <th v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Estimate (Tier 1)</th>
                                                                <th v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'"">Estimate(Tier 2)</th>
                                                                <th v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Free Reading</th>
                                                                <th v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Frequency</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-if="unitArr && unitArr.length > 0">
                                                                <tr v-for="(uData, key) in unitArr" :key="key">
                                                                    <td v-if="uData.section_id">
                                                                        {{uData.section_id.text}}
                                                                    </td>
                                                                    <td v-else>-</td>
                                                                    <td v-if="uData.reading_out_date">{{ uData.reading_out_date }}</td>
                                                                    <td v-else>-</td>
                                                                    <td v-if="uData.reading_out">{{uData.reading_out }}</td>
                                                                    <td v-else>-</td>
                                                                    <td v-if="uData.estimate && contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">{{ uData.estimate }}</td>
                                                                    <td v-else-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">-</td>
                                                                    <td v-if="uData.estimate && contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">{{ uData.estimate2 }}</td>
                                                                    <td v-else-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">-</td>
                                                                    <td v-if="uData.free_reading && contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">{{ uData.free_reading }}</td>
                                                                    <td v-else-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">-</td>
                                                                    <td v-if="uData.frequency && contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">{{ uData.frequency }}&nbsp;Month</td>
                                                                    <td v-else-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">-</td>
                                                                </tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </template>
                                            <template v-if="readInArr && readInArr.length > 0">
                                                <h4> Reading In</h4>
                                                <div v-if="closed == 2" class="table-responsive-sm">
                                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                        <thead>
                                                            <tr class="table-primary">
                                                                <th>Section</th>
                                                                <th>Reading Date</th>
                                                                <th>Reading</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-if="readInArr && readInArr.length > 0">
                                                                <tr v-for="(readIn, inkey) in readInArr" :key="inkey">
                                                                    <td>{{readIn.section}}</td>
                                                                    <td>{{readIn.reading_in_date}}</td>
                                                                    <td>{{readIn.reading_in}}</td>
                                                                </tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <!-- <h4 v-if="readInArr && readInArr.length > 0"> Reading In</h4> -->
                                                <template class="form-group" v-if="readInArr && readInArr.length > 0 && closed != 2">
                                                    <div class="table-responsive-sm">
                                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                            <thead>
                                                                <tr class="table-primary">
                                                                    <th>Section</th>
                                                                    <th class="require">Reading Date</th>
                                                                    <th class="require">Reading</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-if="readInArr && readInArr.length > 0">
                                                                    <tr v-for="(readIn, inkey) in readInArr" :key="inkey">
                                                                        <td>{{readIn.section}}</td>
                                                                        <td class="form-group">
                                                                            <div class="input-group">
                                                                                <date-picker placeholder="MM/DD/YYYY H:i:s" id="reading_date" :disabled="true" name="reading_date" v-model="readIn.reading_in_date" :config="optionsDateTime" aria-describedby="basic-addon3" class="cal-icon adjustHeight"></date-picker>
                                                                                <label for="reading_date" class="fp-calendar input-calender-icon"></label>
                                                                            </div>
                                                                            <div class="field-error">{{readIn.reading_in_date_error_msg}}</div>
                                                                        </td>
                                                                        <td><input type="text" placeholder="Reading In" v-model="readIn.reading_in" class="form-control" @keypress="isAmountCheck($event)">
                                                                        <div class="field-error">{{readIn.reading_in_error_msg}}</div>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </template>

                                             <h4> Charges</h4>
                                            <app-contract-miscellaneous-charge-tab :from="'contract'" ref="misc_charges_module"></app-contract-miscellaneous-charge-tab>

                                          <div v-if="closed == 0 && canUpdateConAsset && contractAssetData.status == 'active'">
                                            <h4>Asset Pool</h4>
                                            <div class="row">
                                              <div class="col-4">
                                                <div class="col form-group">
                                                  <v-select v-model="vehicle_pool_id" name="vehicle_pool_id" placeholder="Select Asset Pool."
                                                            label="text"
                                                            :options="vehiclepoolArr">
                                                  </v-select>
                                                  <div class="field-error" v-fp-html="asset_pool_error"></div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                            <div class="alert-contract error hide"></div>
                                            <div class="btn-groups" v-if="closed != 2">
                                                <button type="submit" id="returnUnit" class="btn btn-primary" v-on:click.prevent="createContractAssetReading('return')">
                                                    <i class="fp-reload"> </i> Update
                                                </button>

                                                <button type="submit" id="CancelAllowanceBtn" class="btn btn-tertiary" v-on:click.prevent="returnFlag = false">
                                                    <i class="fp-close"> </i> Cancel
                                                </button>

                                                <!-- <button type="submit" id="CreateContractAssetDetailBtn" class="btn btn-primary" v-on:click.prevent="CreateContractAssetDetail" >
                                                    <i class="fp-save"> </i>  Return
                                                </button>

                                                <button type="submit" id="cancelContractAssetDetailBtn" class="btn btn-tertiary" v-on:click.prevent="BackContractAssetDetailList" >
                                                    <i class="fp-close"> </i>  Cancel
                                                </button> -->
                                            </div>
                                        </form>
                                </section>
                            </div>
                            <div v-else-if="activetab === 2" class="list-sections">
                                <app-contract-cpi-rate-change-tab></app-contract-cpi-rate-change-tab>
                            </div>
                            <div v-else-if="activetab === 3" class="list-sections">
                                <app-contract-cpi-tab ref="contract_rate_tab" :rateHistoryId="rate_history_id"></app-contract-cpi-tab>
                            </div>
                            <div v-else-if="activetab === 4">
                                <div class="list-sections table-responsive-sm">
                                    <table aria-describedby="table" id="unit_table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Invoice No.</th>
                                                <th>Unit No.</th>
                                                <th>Section/Charge</th>
                                                <th class="text-right">Billed Days</th>
                                                <th class="text-right">Billing Rate</th>
                                                <th class="text-center">&nbsp;</th>
                                                <th class="text-right">Sub Total</th>
                                                <th class="text-right">Discount Amount</th>
                                                <th class="text-right">Billed Amount</th>
                                                <th class="text-right">Billed Date</th>
                                                <!-- <th class="text-right">Billed Taxes</th> -->
                                                <th>Selected</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="billingRecordsArr && billingRecordsArr.length > 0">
                                                <template v-for="(record, index) in billingRecordsArr">
                                                    <tr v-bind:key="'recordRow'+index">
                                                        <td><router-link class="color-blue" target="_blank" v-bind:to="{name: 'LeaseContractInvoice',params:{id:record.invoice_id}}">{{record.invoice_no}}</router-link></td>
                                                        <td>{{record.unit_no}}</td>
                                                        <td>{{record.description}}</td>
                                                        <td class="text-right">{{record.billed_days}}</td>
                                                        <td class="text-right">{{record.rate}}</td>
                                                        <td class="text-center">{{record.per_value}}</td>
                                                        <td class="text-right">{{record.sub_total}}</td>
                                                        <td class="text-right">{{record.discount}}</td>
                                                        <td class="text-right">{{record.billed_amount}}</td>
                                                        <td class="text-right">{{record.invoice_date}}</td>
                                                        <!-- <td class="text-right">{{record.taxes}}</td> -->
                                                        <td>{{record.selected}}</td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <tr><td colspan="8" class="text-center">No Record Found</td></tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="rebill" class="list-sections table-responsive-sm" style="margin-top:30px !important;">
                                    <table aria-describedby="table" id="unit_table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Unit No.</th>
                                                <th>Section/Charge</th>
                                                <th class="text-right">Rate</th>
                                                <th class="text-center">Billing Date</th>
                                                <th class="text-center">Billed Reading</th>
                                                <th class="text-center">Reading Date</th>
                                                <th class="text-center">New Reading</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="billedVariableArr && billedVariableArr.length > 0">
                                                <template v-for="(bill, ind) in billedVariableArr">
                                                    <tr v-bind:key="'recordRow'+ind">
                                                        <td>{{bill.unit_no}}</td>
                                                        <td>{{bill.section}}</td>
                                                        <td class="text-right">{{bill.rate}}</td>
                                                        <td class="text-center">{{bill.invoice_date}}</td>
                                                        <td class="text-center">{{bill.reading_in}}</td>
                                                        <td class="text-center">{{bill.reading_in_date}}</td>
                                                        <td class="text-center">
                                                            <input type="text" placeholder="Reading In" v-model="bill.new_reading" class="form-control" @keypress="isAmountCheck($event)">
                                                            <div class="field-error">{{bill.new_reading_error_msg}}</div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <tr><td colspan="8" class="text-center">No Record Found</td></tr>
                                            </template>
                                        </tbody>
                                    </table>
                                    <div class="btn-groups">
                                        <button type="submit" id="postRebill" class="btn btn-primary" v-on:click.prevent="postRebill()">
                                            <i class="fp-reload"> </i> Update
                                        </button>

                                        <button type="submit" id="cancelRebill" class="btn btn-tertiary" v-on:click.prevent="cancelRebill">
                                            <i class="fp-close"> </i> Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="activetab === 5" class="list-sections">
                                <div class="btn-groups text-right mb-4">
                                    <template v-if="allowancesArr.length == 0">
                                        <button type="submit" class="btn btn-primary" v-on:click="addAllowance()" v-if="!addUpdateAllowance">
                                            <i class="fp-add"></i>Add
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button type="submit" class="btn btn-primary" v-on:click="editAllowance()" v-if="!addUpdateAllowance">
                                            <i class="fp-edit-icon"></i>Edit
                                        </button>
                                    </template>
                                </div>
                                <template>
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" id="unit_table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th>Type</th>
                                                    <th>Description</th>
                                                    <th class="text-right">Allowance Amount</th>
                                                    <th class="text-right">Remaining Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="allowancesArr && allowancesArr.length > 0">
                                                    <template v-for="(record, index) in allowancesArr">
                                                        <tr v-bind:key="'recordRow'+index">
                                                            <td>{{record.allowance_type_code}}</td>
                                                            <td>{{record.allowance_type_desc}}</td>
                                                            <td class="text-right">{{record.formatted_allowance_amount}}</td>
                                                            <td class="text-right">{{record.formatted_remaining_amount}}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <tr><td colspan="8" class="text-center">No Record Found</td></tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>
                                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="allowanceForm" v-if="addUpdateAllowance">
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col" class="require" style="width:400px">Type</th>
                                                    <th scope="col" class="require">Allowance Amount</th>
                                                    <th scope="col"> Action </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(row, index) in rows">
                                                    <tr :key="index">
                                                        <td>
                                                            <v-select v-model="row.allowance_type" name="allowance_type" placeholder="Select Allowance Type." label="text" :options="contractAllowanceArr" class="close-remove" :disabled="row.disabled">
                                                            </v-select>
                                                            <div class="field-error">{{row.allowance_type_error_msg}}</div>
                                                        </td>
                                                        <td>
                                                            <input type="text" placeholder="Allowance Amount"  v-model="row.allowance_amount" @keypress="isAmountCheck($event)" id="allowance_amount" name="allowance_amount" class="form-control text-right" :disabled="row.disableUpdate">
                                                            <div class="field-error">{{row.allowance_amount_error_msg}}</div>
                                                        </td>
                                                        <td class="text-center" style="vertical-align:middle">
                                                            <template v-if="rows.length > 1">
                                                                <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeAllowance(index);"> <i class="fp-close color-red"></i> </a></span>
                                                            </template>
                                                            <template v-else>
                                                                <span class="close-row"> _ </span>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                        <i class="fp-add"></i>Add Line Item
                                    </button>
                                    <div class="btn-groups mt-4">
                                        <button type="submit" v-if="allowancesArr.length > 0" id="CreateAllowanceBtn" class="btn btn-primary" v-on:click.prevent="createAllowance">
                                            <i class="fp-reload"> </i> Update
                                        </button>

                                        <button type="submit" v-else id="CreateAllowanceBtn" class="btn btn-primary" v-on:click.prevent="createAllowance">
                                            <i class="fp-save"> </i> Save
                                        </button>
                                        <button type="submit" id="CancelAllowanceBtn" class="btn btn-tertiary" v-on:click.prevent="backAllowanceList">
                                            <i class="fp-close"> </i> Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div v-else-if="activetab === 6" class="list-sections">

                                <template v-if="onlyList == true">
                                    <h4> Reading Out</h4>
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th>Section</th>
                                                    <th>Reading Date</th>
                                                    <th style="text-align:right">Reading</th>
                                                    <th style="text-align:right" v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Estimate(Tier 1)</th>
                                                    <th style="text-align:right" v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Estimate(Tier 2)</th>
                                                    <th style="text-align:right" v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Free Reading</th>
                                                    <th style="text-align:right" v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Frequency</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="unitArr && unitArr.length > 0">
                                                    <tr v-for="(uData, key) in unitArr" :key="key">
                                                        <td v-if="uData.section_id">
                                                            {{uData.section_id.text}}
                                                        </td>
                                                        <td v-else>-</td>
                                                        <td v-if="uData.reading_out_date">{{ uData.reading_out_date }}</td>
                                                        <td v-else>-</td>
                                                        <td style="text-align:right" v-if="uData.reading_out">{{uData.reading_out }}</td>
                                                        <td style="text-align:right" v-else>-</td>
                                                        <td style="text-align:right" v-if="uData.estimate && contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">{{ uData.estimate }}</td>
                                                        <td style="text-align:right" v-else-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">-</td>
                                                        <td style="text-align:right" v-if="uData.estimate && contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">{{ uData.estimate2 }}</td>
                                                        <td style="text-align:right" v-else-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">-</td>
                                                        <td style="text-align:right" v-if="uData.free_reading && contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">{{ uData.free_reading }}</td>
                                                        <td style="text-align:right" v-else-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">-</td>
                                                        <td style="text-align:right" v-if="uData.frequency && contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">{{ uData.frequency }}&nbsp;Month</td>
                                                        <td style="text-align:right" v-else-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">-</td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <template v-if="readInArr && readInArr.length > 0">
                                        <h4> Reading In</h4>
                                        <div class="table-responsive-sm">
                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th>Section</th>
                                                        <th>Reading Date</th>
                                                        <th>Reading</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-if="readInArr && readInArr.length > 0">
                                                        <tr v-for="(readIn, inkey) in readInArr" :key="inkey">
                                                            <td>{{readIn.section}}</td>
                                                            <td>{{readIn.reading_in_date}}</td>
                                                            <td>{{readIn.reading_in}}</td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-if="sectionOutFound==true">
                                    <h4> Reading Out</h4>
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th>Section</th>
                                                    <th class="require w-25">Reading Date</th>
                                                    <th class="require">Reading</th>
                                                    <th class="require" v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Estimate(Tier 1)</th>
                                                    <th class="require" v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Estimate(Tier 2)</th>
                                                    <th v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Free Reading</th>
                                                    <th v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">Frequency</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="unitArr && unitArr.length > 0">
                                                    <tr v-for="(uData, key) in unitArr" :key="key">
                                                        <template v-if="uData.showDiv">
                                                          <td v-if="uData.add_line != undefined && uData.add_line == 'line'">
                                                            <v-select class="section-id" v-model="uData.section_id" name="rate_section" placeholder="Select Section Rate"
                                                                      label="text"
                                                                      :options="sectionTypes">
                                                            </v-select>
                                                            <div class="field-error">{{ uData.section_error_msg }}</div>
                                                          </td>
                                                          <td v-else>
                                                            <label v-if="uData.section_id">
                                                              {{uData.section_id.text}}
                                                            </label>
                                                          </td>

                                                          <td class="form-group">
                                                            <div class="input-group">
                                                              <date-picker placeholder="MM/DD/YYYY H:i:s" id="reading_date" name="reading_date" v-model="uData.reading_out_date" :config="optionsDateTime" aria-describedby="basic-addon3" class="cal-icon adjustHeight"></date-picker>
                                                              <label for="reading_date" class="fp-calendar input-calender-icon"></label>
                                                            </div>
                                                            <div class="field-error">{{ uData.reading_out_date_error_msg }}</div>
                                                          </td>
                                                          <td>
                                                            <input type="text" v-model="uData.reading_out" placeholder="Reading Out" class="form-control" @keypress="isAmountCheck($event)">
                                                            <div class="field-error">{{ uData.reading_out_error_msg }}</div>
                                                          </td>
                                                          <td v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">
                                                            <input type="text" v-model="uData.estimate" placeholder="Estimate Reading" class="form-control" @keypress="isAmountCheck($event)">
                                                            <div class="field-error">{{ uData.estimate_error_msg }}</div>
                                                          </td>
                                                          <td v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">
                                                            <input type="text" v-model="uData.estimate2" placeholder="Estimate Reading" class="form-control" @keypress="isAmountCheck($event)">
                                                            <!-- <div class="field-error">{{ uData.estimate2_error_msg }}</div> -->
                                                          </td>
                                                          <td v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">
                                                            <input type="text" v-model="uData.free_reading" placeholder="Free Reading" class="form-control" @keypress="isAmountCheck($event)">
                                                            <div class="field-error">{{ uData.free_reading_error_msg }}</div>
                                                          </td>
                                                          <td v-if="contractAssetData.ctCode != 'M3' && contractAssetData.ctCode != 'M2'">
                                                            <input type="text" v-model="uData.frequency" placeholder="In Months" class="form-control" @keypress="isIntegerCheck($event)">
                                                            <input type="hidden" v-model="uData.ref_miles" placeholder="In Months" class="form-control adjustHeight">
                                                            <input type="hidden" v-model="uData.ref_reading_date" placeholder="In Months" class="form-control adjustHeight">
                                                            <div class="field-error">{{ uData.frequency_error_msg }}</div>
                                                          </td>
                                                          <td>
                                                            <template v-if="unitArr.length != 1">
                                                              <a href="javascript:void(0)" v-on:click.prevent="removeElement(key);"> <i class="fp-remove"></i> </a>
                                                            </template>
                                                            <template v-else>
                                                              <span class="close-row"> _ </span>
                                                            </template>
                                                          </td>
                                                      </template>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                        <div class="btn-groups">
                                            <button type="submit" v-on:click.prevent="addLineItem()" class="btn btn-primary">
                                                <i class="fp-add"></i> Add Line Item
                                            </button>
                                        </div>
                                        <p>&nbsp;</p>

                                    </div>
                                    </template>
                                    <template v-else>
                                            <p> No Section Found Please add section in Asset Type.</p>
                                    </template>
                                    <!-- <h4 v-if="readInArr && readInArr.length > 0"> Reading In</h4>
                                    <template class="form-group" v-if="readInArr && readInArr.length > 0">
                                        <div class="table-responsive-sm">
                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th>Section</th>
                                                        <th class="require">Reading Date</th>
                                                        <th class="require">Reading</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-if="readInArr && readInArr.length > 0">
                                                        <tr v-for="(readIn, inkey) in readInArr" :key="inkey">
                                                            <td>{{readIn.section}}</td>
                                                            <td>
                                                                <div class="input-group">
                                                                    <date-picker placeholder="MM/DD/YYYY H:i:s" id="reading_date" name="reading_date" v-model="readIn.reading_in_date" :config="optionsDateTime" aria-describedby="basic-addon3" class="cal-icon adjustHeight"></date-picker>
                                                                    <label for="reading_date" class="fp-calendar input-calender-icon"></label>
                                                                </div>
                                                                <div class="field-error">{{readIn.reading_in_date_error_msg}}</div>
                                                            </td>
                                                            <td><input type="text" placeholder="Reading In" v-model="readIn.reading_in" class="form-control" @keypress="isAmountCheck($event)">
                                                            <div class="field-error">{{readIn.reading_in_error_msg}}</div>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template> -->
                                    <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="allowanceForm">
                                        <div class="btn-groups" v-if="sectionOutFound==true">
                                            <button type="submit" id="CreateAllowanceBtn" class="btn btn-primary" v-on:click.prevent="createContractAssetReading('')">
                                                <i class="fp-reload"> </i> Update
                                            </button>

                                            <button type="submit" id="CancelAllowanceBtn" class="btn btn-tertiary" v-on:click.prevent="loadContract(),onlyList = true">
                                                <i class="fp-close"> </i> Cancel
                                            </button>
                                        </div>
                                        <div v-else>
                                            <button type="submit" class="btn btn-secondary" v-on:click.prevent="onlyList = true">
                                                <i class="fp-back"> </i>    Back
                                            </button>
                                        </div>
                                    </form>
                                </template>
                                <div class="btn-groups text-right" v-if="closed == 0">
                                    <template v-if="unitArr.length == 0">
                                        <button type="submit" class="btn btn-primary" v-on:click="onlyList = false" v-if="onlyList">
                                            <i class="fp-add"></i>Add
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button type="submit" class="btn btn-primary" v-on:click="onlyList = false" v-if="onlyList">
                                            <i class="fp-edit-icon"></i>Edit
                                        </button>
                                    </template>
                                </div>
                            </div>
                            <div v-else-if="activetab === 7" class="list-sections">
                                <div class="form-row no-divider" v-if="licenseDetail.permit_no != undefined && licenseDetail.permit_no != null">
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Permit No. :</label>
                                            <span class="col">{{licenseDetail.permit_no}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Permit Type. :</label>
                                            <span class="col">{{licenseDetail.permit_type}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Expiry Date :</label>
                                            <span class="col">{{licenseDetail.expiry_date}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Permit Description :</label>
                                            <span class="col">{{licenseDetail.permit_desc}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Effective Date :</label>
                                            <span class="col">{{licenseDetail.effective_date}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    No Data Found.
                                </div>
                            </div>
                            <div v-else-if="activetab === 8" class="list-sections">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col">
                                        <label class="control-label" for="label_policy">Insurance Policy:</label>
                                    </div>
                                </div>
                                <div class="table-responsive" v-if="insurancePolicyArr && insurancePolicyArr.length > 0">
                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" style="width:10px;" v-if="addInsurancePolicy"></th>
                                                <th style="width:60px;">Policy Number</th>
                                                <th>Insurance Company</th>
                                                <th>Agent Name</th>
                                                <th>Agent Contact</th>
                                                <th>Status</th>
                                                <th>Start Date</th>
                                                <th>Expiry Date</th>
                                                <th>Blanket Policy</th>
                                                <th>Policy Type</th>
                                                <th>Self Insured For</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in insurancePolicyArr" :key="'policy' + index">
                                                <template v-if="addInsurancePolicy">
                                                    <td scope="col" style="width:10px;" v-if="row.status.toLowerCase() == 'active'"><!-- Active Policy allowed to select-->
                                                        <input type="checkbox" :id="'selectCheckbox' + index" @input="policySelect($event,row,index)"/>
                                                    </td>
                                                    <td scope="col" style="width:10px;" v-else>&nbsp;&nbsp;</td>
                                                </template>
                                                <td  style="width:60px;">{{row.policy_number}}</td>
                                                <td>{{row.insurance_company_name}}</td>
                                                <td>{{row.agent_name}}</td>
                                                <td>{{row.agent_contact}}</td>
                                                <td>{{row.status}}</td>
                                                <td>{{row.start_date}}</td>
                                                <td>{{row.expiry_date}}</td>
                                                <td v-if="row.is_lease_blanket == 1">Yes</td>
                                                <td v-else>No</td>
                                                <td>{{row.policy_type}}</td>
                                                <td>{{row.self_insured_for}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else>
                                    <p>&nbsp;</p>
                                    No policy found.
                                </div>
                                <div class="field-error">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="insuranceDocForm"  v-if="insurancePolicyArr && insurancePolicyArr.length > 0">
                                    <div class="btn-groups">
                                        <button type="submit" id="uploadInsuranceDoc" class="btn btn-primary" v-on:click.prevent="storeInsuranceDoc">
                                            <i class="fp-save"> </i> Save
                                        </button>
                                    </div>
                                </form>
                                <!-- <div class="custom-dropzone-container custom-photo-user-dropzone dropzone-margin">
                                    <label class="control-label" for="documents">Documents (.jpg, .jpeg, .png, .pdf and .doc files are allowed)</label>
                                    <div id="app2">
                                        <vue-dropzone
                                            id="selfInsuranceDocs"
                                            :options="dropzoneOptions"
                                            :destroyDropzone=false
                                            ref="insuredDropzone"
                                            :headers="dropzoneOptions.headers"
                                            @vdropzone-complete="afterComplete"
                                            @vdropzone-success="storeDocument"
                                            @vdropzone-removed-file="removedSelectedFile"
                                            >
                                        </vue-dropzone>
                                        <div class="field-error">{{doc_error_msg}}</div>
                                        <div  v-if="dropZonePreviewFiles.length > 0">
                                            <div class="policy-attachment attachment-list-box">
                                                <label class="control-label" for="attachments">Attachments</label>
                                                <template  v-for="(uFile,fKey) in dropZonePreviewFiles">
                                                    <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                                        <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                        <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                                        <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                                        <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                            {{ uFile['display_name'] }}
                                                        </a>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeServerFile(uFile['file_name'],fKey);">
                                                            <i class="fp-close"></i>
                                                        </button>
                                                    </div>

                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field-error">{{common_error_msg}}</div>
                                    <div class="form-group">
                                        <div class="alert alert-warning hide col-sm-6" id="alertError">
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                            <strong id="errorMsg" class="field-error"></strong>
                                        </div>
                                    </div>
                                    <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="insuranceDocForm">
                                        <div class="btn-groups">
                                            <button type="submit" id="uploadInsuranceDoc" class="btn btn-primary" v-on:click.prevent="storeInsuranceDoc">
                                                <i class="fp-save"> </i> Save
                                            </button>
                                        </div>
                                    </form>
                                </div>-->
                            </div>
                             <div v-else-if="activetab === 9" class="list-sections">
                                 <app-contract-miscellaneous-charge-tab :from="'contract'"></app-contract-miscellaneous-charge-tab>
                            </div>
                             <div id="customer-invoice-list" class="list-sections" v-else-if="activetab === 10">
                                <!-- <section class="internal-container border-top-table-fl"> -->
                                    <div class="bg-white data-table p-0">
                                        <app-customer-invoice v-if="customerInvoiceLoad" :moduleVal="'conAsset'" :listFlag="'conAsset'" :customerId="contractVehicleId"></app-customer-invoice>
                                    </div>
                                <!-- </section> -->
                            </div> <!--Customer Invoice List -->
                            <div id="contract-activity-log" class="list-view" v-show="activetab == 11">
                                <div class="bg-white data-table p-0">
                                    <contract-activity-log-list :activityLogVal="activityLogsTabValue"></contract-activity-log-list>
                                </div>
                            </div>
                        </section>
                        <div class="modal fade make-bill-date-modal" id="postInvoiceModal" ref="postInvoiceModal" data-backdrop="static" data-keyboard="false" aria-labelledby="makePaymentModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Post Invoice</h5>
                                        <button type="button" class="close" id="btnBillModalClose" v-on:click="hideBillModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="form-row">
                                            <div class="col-md-4 form-group" v-if="!invFirst">
                                                <label class="control-label require" for="bill_date">Bill Date:</label>
                                                <div class="input-group">
                                                    <date-picker placeholder="MM/DD/YYYY" id="bill_date" name="bill_date" v-model="bill_date" :config="optionsDate"></date-picker>
                                                    <label for="bill_date" class="fp-calendar input-calender-icon"></label>
                                                </div>
                                                <div class="field-error">{{ bill_date_error }}</div>
                                            </div>
                                        </div>
                                        <div class="table-responsive-sm">
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th>Unit No.</th>
                                                        <th>Section/Charge</th>
                                                        <th class="text-right">Billed Days</th>
                                                        <th class="text-right">Billing Rate</th>
                                                        <th class="text-center">&nbsp;&nbsp;</th>
                                                        <th class="text-right">Billed Amount</th>
                                                        <!-- <th class="text-right">Billed Taxes</th> -->
                                                        <th class="text-center">Selected</th>
                                                        <th class="text-center" v-if="!invFirst">&nbsp;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-if="billingArr && billingArr.length > 0">
                                                        <template v-for="(bill, index) in billingArr">
                                                            <tr v-bind:key="'recordRow'+index">
                                                                <td>{{bill.unit_no}}</td>
                                                                <td>{{bill.description}}</td>
                                                                <!-- <td class="text-right" v-if="!invFirst"><input class="form-control" v-model="bill.billed_days" @input="changeQuantity(index)"/></td> -->
                                                                <td class="text-right">{{bill.billed_days}}</td>
                                                                <td class="text-right">{{bill.rate}}</td>
                                                                <td class="text-center">{{bill.per_value}}</td>
                                                                <td class="text-right">{{bill.billed_amount}}</td>
                                                                <!-- <td class="text-right">{{bill.taxes}}</td> -->
                                                                <td class="text-center">{{bill.selected}}</td>
                                                                <td class="text-center" v-if="!invFirst">
                                                                    <a href="javascript:void(0)" v-on:click.prevent="removeBillElement(index);"> <i class="fp-remove"></i> </a>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <tr><td colspan="8" class="no-data-field">No Record Found</td></tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                            <p style="color:red" v-if="!invFirst && !amountFound">No billing found. You can close the contract by clicking on Close</p>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <div class="btn-groups">
                                            <button class="btn btn-primary" v-if="invFirst || amountFound" id="btnPostInvoiceModalProcess" v-on:click="postInvoice()"> Post Invoice </button>
                                            <button class="btn btn-primary" v-if="!invFirst && !amountFound" id="btnPostInvoiceModalClose" v-on:click="closeContract()"> Close </button>
                                            <button class="btn btn-tertiary" id="btnPostInvoiceModalCancel" v-on:click="hideBillModal()"> Cancel </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade trigger-message-modal" v-show="displaySchedule" id="trigger-message-modal" ref="triggerMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="triggerMessageModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Maintenance For:</h5>
                                        <button type="button" class="close" id="btnPermitModalMessageClose" v-on:click="checkTriggers('no_action')">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <app-program-trigger :from="'contract asset'" ref="triggerEnable"></app-program-trigger>
                                    </div>
                                    <div class="modal-footer">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>


    </div>
</template>
<script>
import Vue from "vue";

import TabContractCPIRateChangeHistory from "@/components/contract/TabContractCPIRateChangeHistory";
import {commonMixins} from '../../mixins/commonMixins';

import ContractCPITabView from "@/components/ContractCPITabView";
import MiscellaneousChargeTabView from "@/components/ContractMiscellaneousChargeTabView";
import appCustomerInvoice from "@/components/invoice/InvoiceList";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import moment from 'moment'
import ProgramTrigger from "@/components/ProgramTrigger.vue";


Vue.component("app-contract-cpi-rate-change-tab", TabContractCPIRateChangeHistory);
Vue.component("app-contract-cpi-tab", ContractCPITabView);
Vue.component("app-contract-miscellaneous-charge-tab", MiscellaneousChargeTabView);
Vue.component("app-customer-invoice", appCustomerInvoice);
Vue.component("app-program-trigger", ProgramTrigger);

    export default {
        name: "ContractAssetView",
        components: {
            vueDropzone: vue2Dropzone,

            ContractActivityLogList: () => import('@/components/ActivityLogList.vue'),
        },
        mixins:[commonMixins],
        data: () => ({
            isRefInq: false,
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            contractAssetData: [],
            loading:false,
            activetab: 1,
            canListConAsset:false,
            canUpdateConAsset:false,
            closed:0,
            bill_date_error:'',
            bill_date:'',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: true,
            },
            optionsDateTime:{
                format: 'MM/DD/YYYY hh:mm:ss a',
                useCurrent: true,
                showClose:true
            },
            billingRecordsArr:[],
            pageKey:"",
            subKey1:"",
            subKey2:"",
            allowancesArr:[],
            allowancesFound:false,
            addUpdateAllowance:false,
            rows:[],
            unitArr:[],
            readInArr:[],
            returnFlag:false,
            onlyList:true,
            contract_id:0,
            sectionOutFound:false,
            licenseDetail:[],
            previewSelfInsuredFiles:[],
            dropzoneOptions: {
                url: process.env.ROOT_API +"/store-contract-insurance-docs",
                method: 'POST',
                maxFilesize: 5.00, //MB
                maxFiles: 1,
                thumbnailWidth: 150, // px
                thumbnailHeight: 150,
                addRemoveLinks: true,
                acceptedFiles: ".jpg, .jpeg, .png, .pdf , .doc ,.docx",
                headers: {
                    'Accept': 'application/json',
                    "Authorization": "Bearer "+localStorage.getItem("tkn"),
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                    "Cache-Control": "no-cache"
                },
                dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
                destroyDropzone:false,
                dictDefaultMessage: "Drop files here to upload. Files upto maximum 5 MB size are allowed.",
            },
            dropZonePreviewFiles:[],
            files:[],
            doc_error_msg:'',
            validateDocs:[],
            contractCpiRateHistoryVal:"dontLoadList",
            sectionTypes:[],
            expiry_date:'',
            expiry_date_error_msg:'',
            billedVariableArr:[],
            rebill:false,
            vehicle_id:0,
            customerInvoiceLoad:false,
            contractVehicleId:0,
            billingArr:[],
            amountFound:false,
            displaySchedule:false,
            returnContractList: [],
            invFirst:false,
            alreadyBilled:'no',
            residual:'',
            fromUrl:"",
            activityLogsTabValue:"dontLoadList",
            tabMenuArray:[],
            policyLabelArr:[],
            customer_id:'',
            contract_type_id:'',
            truck_type_id:'',
            effDate:'',
            expDate:'',
            insurancePolicyArr:[],
            addInsurancePolicy:true,
            insPolicyArr:[],
            common_error_msg:'',
            rate_history_id:'',
            history_section_id :'',
            vehicle_pool_id: null,
            vmPoolId: '',
            vehiclepoolArr: [],
            asset_pool_error:"",
            old_expiry:'',
            postOnce:0,
            editPurchaseOrder: true,
            poArr:[],
            po:null,
            customer_po_error_msg:'',
        }),
        metaInfo() {
            return {
                title: (this.contractAssetData.contName != "" && this.contractAssetData.contName != undefined) ? this.contractAssetData.contName + " Contract Asset View | " +process.env.COPYRIGHT_NAME:"Contract Asset View | " +process.env.COPYRIGHT_NAME
            }
        },
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_contract_asset_detail') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'list_contract_asset_detail') {
                            self.canListConAsset = true;
                        }
                        if (permissions[i].name == 'add_contract_asset_detail') {
                            self.canUpdateConAsset = true;
                        }
                    }
                }

            },
            // expiry_date: function(val) {
            //     var self = this;

            //     if (self.readInArr.length){
            //         for (var i = 0; i < self.readInArr.length; i++) {

            //             self.readInArr[i].reading_in_date = moment(self.expiry_date+' 10:00:00 am').format("MM/DD/YYYY hh:mm:ss a");

            //         }
            //     }
            //     if (self.$refs.misc_charges_module != undefined){
            //         self.$refs.misc_charges_module.loadChargeData(val);
            //     }
            // },
            rate_history_id: function(val) {
                var self = this;
                setTimeout(function(){
                    self.rate_history_id = val;
                    self.activetab = 3;
                    $("#contract_rate_tab").click();
                },500);
                // self.getRateHistoryData(val, history_section_id);
            },
        },
        created: function() {

        },
        destroyed() {
          var path = window.location.pathname;
          var segments = path.split("/");
          if(segments[1] == "contractassetdetail") {
            if(segments[2] == 'view') {

            } else {
              localStorage.removeItem("return_contract_list");
            }
          } else {
            localStorage.removeItem("return_contract_list");
          }
        },
        beforeRouteLeave(to, from, next) {
            var self = this;
            self.left_view_edit_channel(from.fullPath);
            next();
        },
        mounted: function() {
            var self = this;
            self.fromUrl = btoa(window.location.pathname);
            self.getPermissions();
            self.loadContract();

            if(localStorage.getItem('return_contract_list') === null) {

            } else {
              self.returnContractList = localStorage.getItem('return_contract_list').split(",");
            }
            console.log(self.returnContractList);

            //to stop calling all request same time
            setTimeout(function () {
                // self.billingRecords();
                self.contractAllowanceList();
                self.getSectionTypes();
            },3000);

            // isRefInq
            console.log(self.$route.query.from);
            if (self.$route.query.from != undefined) {
              this.isRefInq = true;
            } else {
              this.isRefInq = false;
            }

            var path = window.location.pathname;
            var segments = path.split("/");
            self.pageKey='_contract_asset_view_'+segments[3];
            self.subKey1='_contract_section_rate_history_view_'+segments[3];
            self.subKey2='_contract_section_rate_view_'+segments[3];
            self.contractVehicleId = segments[3];

            if (self.$route.query.batch != undefined && self.$route.query.batch != ''){
                self.returnContractAsset();
            }

            //Join ViewEdit Channel
            self.join_view_edit_channel(segments[1],segments[2],segments[3]);
        },
        methods: {
            ChangeExpiry: function(val) {
                var self = this;

                if (self.readInArr.length){
                    for (var i = 0; i < self.readInArr.length; i++) {

                        self.readInArr[i].reading_in_date = moment(self.expiry_date+' 10:00:00 am').format("MM/DD/YYYY hh:mm:ss a");

                    }
                }
                if (self.$refs.misc_charges_module != undefined){
                    self.$refs.misc_charges_module.loadChargeData(val,'date');
                }
            },
            goPreviousPath() {
              this.$router.go(-1);
            },

            handleClick(newTab) {

                var self = this;
                self.currentTab = newTab;
            },

            selectTab(flag){

                alert("You are select " + flag);

            },
            cpiRateHistoryClicked(){
                var self = this;
                self.activetab = 2;

                self.contractCpiRateHistoryVal = "loadList";     // flag value set to loadList so that filters in list work properly.
            },
            loadContract() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/contractassetdetail/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{
                        action_flag : 'view', // pass action for notify: view, edit
                        is_notify_flag : true // notify if user viewing or editing
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.vehiclepoolArr = data.vehiclePoolData;
                            self.contractAssetData = data.content;
                            self.vehicle_id = data.content.vehicle_id;
                            self.closed = data.content.closed;
                            self.customer_id = data.content.customer_id;
                            self.contract_type_id = data.content.contractTypeId;
                            self.unitArr = [];
                            self.alreadyBilled = data.content.billed;
                            self.truck_type_id = data.content.vmTypeId;
                            self.effDate = data.content.effective_date;
                            self.expDate = data.content.expiry_date;
                            self.vmPoolId = self.contractAssetData.vmPoolId;

                          for(var j =0;j < self.vehiclepoolArr.length;j++){
                            if (self.vehiclepoolArr[j].value == self.vmPoolId){
                              self.vehicle_pool_id = {text:self.vehiclepoolArr[j].text,value:self.vehiclepoolArr[j].value}; // making sure the existing pool of the unit is selected first
                            }
                          }

                            if (data.content.readingOut && data.content.readingOut.length > 0){
                                self.sectionOutFound=true;
                                for (var i = 0; i < data.content.readingOut.length; i++) {
                                  var showDiv = true
                                  if (data.content.type_metric != null && data.content.type_metric != undefined){
                                    var type_metric = JSON.parse(data.content.type_metric).filter(item => item.sectionName.toLowerCase() == data.content.readingOut[i].sectionName.toLowerCase())
                                    if(type_metric.length > 0 && type_metric[0].read_on_contract == 'skip' && data.content.reading_added == 'false'){
                                        showDiv = false
                                        //no need to hide reading section while update contract asset
                                    }else{

                                    }
                                  }

                                    self.unitArr.push({
                                        section_id:{text:data.content.readingOut[i].section,value:data.content.readingOut[i].section_id},
                                        reading_out:data.content.readingOut[i].reading_out,
                                        reading_out_error_msg:'',
                                        reading_out_date:data.content.readingOut[i].reading_date,
                                        reading_out_date_error_msg:'',
                                        estimate:(data.content.readingOut[i].estimate != undefined) ? data.content.readingOut[i].estimate : '',
                                        estimate2:(data.content.readingOut[i].estimate2 != undefined) ? data.content.readingOut[i].estimate2 : '',
                                        frequency:(data.content.readingOut[i].frequency != undefined) ? data.content.readingOut[i].frequency : '',
                                        estimate_error_msg:'',
                                        ref_miles:(data.content.readingOut[i].miles != undefined) ? data.content.readingOut[i].miles != undefined : '',
                                        ref_reading_date:(data.content.readingOut[i].ref_reading_date != undefined ) ? data.content.readingOut[i].ref_reading_date : '',
                                        sectionName:data.content.readingOut[i].sectionName,
                                        free_reading:(data.content.readingOut[i].free_reading != undefined) ? data.content.readingOut[i].free_reading : '',
                                        free_reading_error_msg:'',
                                        showDiv: showDiv
                                    });
                                }
                            }else{
                                self.sectionOutFound=false;
                                self.unitArr.push({
                                    section_id:null,
                                    section_error_msg:'',
                                    reading_out:'',
                                    reading_out_error_msg:'',
                                    reading_out_date:moment(self.contractAssetData.effective_date+' 10:00:00 am').format("MM/DD/YYYY hh:mm:ss a"),
                                    reading_out_date_error_msg:'',
                                    estimate_error_msg:'',
                                    estimate:'',
                                    estimate2:'',
                                    ref_miles:'',
                                    ref_reading_date:'',
                                    sectionName:'',
                                    free_reading:'',
                                    free_reading_error_msg:'',
                                });
                            }
                            self.readInArr = [];
                            console.log("unitArrunitArr", self.unitArr)
                            if (self.closed){
                                if (data.content.readingIn && data.content.readingIn.length > 0){
                                for (var i = 0; i < data.content.readingIn.length; i++) {

                                    self.readInArr.push({
                                        section_id:data.content.readingIn[i].section_id,
                                        section:data.content.readingIn[i].section,
                                        reading_in:data.content.readingIn[i].reading_in,
                                        reading_in_error_msg:'',
                                        reading_in_date:data.content.readingIn[i].reading_date,
                                        reading_in_date_error_msg:'',
                                    });
                                }
                            }
                            }else
                            if (self.returnFlag){
                                if (data.content.readingOut && data.content.readingOut.length > 0){
                                    for (var i = 0; i < data.content.readingOut.length; i++) {

                                        self.readInArr.push({
                                            section_id:data.content.readingOut[i].section_id,
                                            section:data.content.readingOut[i].section,
                                            reading_in:'',
                                            reading_in_error_msg:'',
                                            reading_in_date:moment().format('MM/DD/YYYY hh:mm:ss a'),
                                            reading_in_date_error_msg:'',
                                        });
                                    }
                                }
                            }

                            self.contract_id=data.content.contract_id;
                            if (data.content.license_details != undefined) {
                                self.licenseDetail = data.content.license_details;
                            }else{
                                self.licenseDetail = [];
                            }
                            if (data.content.file_path != null){

                                self.dropZonePreviewFiles = data.content.file_path;
                                self.loadFilesPreview();

                            }

                            self.residual = data.content.residual;
                        }
                        // self.$refs.misc_charges_module.loadChargeData('');
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            returnContractAsset: function(){
                var self = this;
                // if (moment().format("MM/DD/YYYY") != moment(self.contractAssetData.expiry_date).format("MM/DD/YYYY")){
                //     self.$swal('','Please update expiry date to current date first','info');
                //     return;
                // }
                self.loadContract();
                self.expiry_date = moment().format("MM/DD/YYYY");
                self.activetab = 1;
                self.returnFlag = true;
                self.onlyList = false;
                self.ChangeExpiry(self.expiry_date);
                // self.$router.push('/contractassetdetail/edit/'+self.$route.params.id+'?from=return');
            },

            openModal: function(flag){
                var self = this;
                if (flag == 'first'){
                    self.invFirst = true;
                }
                self.fetchBilling(flag);
                $("#postInvoiceModal").modal("show");
            },
            hideBillModal() {
                var self = this;
                self.invFirst = false;
                $("#postInvoiceModal").modal("hide");
                self.bill_date = '';
                self.bill_date_error = '';
            },

            postInvoice() {
                var self = this;
                // var forecastId = self.$route.params.id;

                var path = window.location.pathname;
                var segments = path.split("/");
                var invoiceFor = 'last';
                if (!self.invFirst){
                    self.bill_date_error = '';

                    if (self.bill_date == '' || self.bill_date == null){
                        self.bill_date_error = 'Bill Date Required';
                        return;
                    }

                    if (self.bill_date != '' && new Date(self.bill_date) < new Date(self.contractAssetData.expiry_date)){
                        self.bill_date_error = 'Bill Date Should Not Be less then Actual In Date';
                        return;
                    }

                    if (self.billingArr == null || self.billingArr.length == undefined || self.billingArr.length < 1){
                        self.$swal('','No Charges Added please click on cancel','info');
                        return;
                    }
                }else{
                    invoiceFor = 'first';
                }

                if (self.postOnce == 1){
                    return;
                }
                self.postOnce = 1;

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/contract-asset-invoice/post",
                    type: "POST",
                    data: {
                        contract_asset_id:segments[3],
                        bill_date:self.bill_date,
                        invoiceFor:invoiceFor,
                        billing_arr:self.billingArr
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.postOnce = 0;

                        if (data.status == "success") {
                            if (data.code == 201){

                                self.$swal('',data.message,'info');
                                self.bill_date = '';
                                self.bill_date_error = '';

                                $("#postInvoiceModal").modal("hide");

                            }else{
                                self.bill_date = '';
                                self.bill_date_error = '';
                                $("#postInvoiceModal").modal("hide");
                            }

                            if (data.code == 200 && invoiceFor == 'last') {
                                self.$swal('',data.message,'success');
                                // APPLY CONDITION
                                if(self.contractAssetData.ctCode == "M1" || self.contractAssetData.ctCode == "M3") {
                                  setTimeout(function () {
                                    self.$swal({
                                        title: '',
                                        text: 'Do you want to Void this Unit',
                                        type: 'info',
                                        showCancelButton: true,
                                        confirmButtonText: 'Yes',
                                        cancelButtonText: 'No',
                                        showCloseButton: true,
                                        showLoaderOnConfirm: true
                                    }).then((result) => {
                                        if (result.value) {
                                            // API CALL
                                            self.voidAssetStatus();
                                        } else {
                                            // this.$swal('Cancelled', 'Your action was canceled', 'info');
                                        }
                                        self.applyMultipleTermination();
                                        // console.log("ACTION PERFORM");

                                        // // var idx = self.returnContractList.indexOf(segments[3]);
                                        // var idx = self.returnContractList.findIndex(obj => obj == segments[3]);
                                        // if(idx !== -1) {
                                        //   self.returnContractList.splice(idx,1);
                                        // }
                                        // if(self.returnContractList.length > 0) {
                                        //   localStorage.setItem("return_contract_list",self.returnContractList);
                                        //   self.$router.push("/contractassetdetail/view/" + self.returnContractList[0]);
                                        // }
                                    });
                                  }, 1000);
                                  if (self.$route.query.batch != undefined && self.$route.query.batch != ''){
                                  }else{
                                    self.loadContract();
                                  }
                                } else {
                                     if (self.$route.query.batch != undefined && self.$route.query.batch != ''){
                                    }else{
                                        self.loadContract();
                                        setTimeout(function () {
                                            self.applyMultipleTermination();
                                        }, 1000);
                                    }
                                }
                                if (self.$route.query.batch != undefined && self.$route.query.batch != ''){
                                    var oldExp = '';
                                    if (localStorage.getItem('old_expiry') != undefined){
                                        oldExp = localStorage.getItem('old_expiry');
                                        localStorage.removeItem('old_expiry');
                                    }
                                    setTimeout(function () {
                                        self.$router.push('/contractassetdetail/add?batch='+self.$route.query.batch+'&&id='+segments[3]+'&&old_expiry='+oldExp);
                                    }, 1000);
                                    return;
                                }
                                if(self.returnContractList == null) {
                                  self.loadContract();
                                }

                            }else{
                                self.loadContract();
                            }

                        }else{

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.postOnce = 0;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            applyMultipleTermination() {
              var self = this;
              var path = window.location.pathname;
              console.log("ACTION PATH= ", path);
              var segments = path.split("/");
              console.log("ACTION PERFORM");
              // var idx = self.returnContractList.indexOf(segments[3]);
              var idx = self.returnContractList.findIndex(obj => obj == segments[3]);
              if(idx !== -1) {
                self.returnContractList.splice(idx,1);
              }
              if(self.returnContractList.length > 0) {
                localStorage.setItem("return_contract_list",self.returnContractList);
                self.$router.push("/contractassetdetail/view/" + self.returnContractList[0]);
              }

            },
            voidAssetStatus() {
              var self = this;
              // var path = window.location.pathname;
              // var segments = path.split("/");

              self.loading = true;

              $.ajax({
                  url: process.env.ROOT_API + "/contract-asset/void-status",
                  type: "POST",
                  headers: this.ajxHeaders,
                  dataType: "json",
                  data:{
                      vehicle_id: self.vehicle_id,
                      status: "Void"
                  },
                  success: function (data) {

                      self.loading = false;

                      if (data.status == "success") {
                          self.$swal('', data.message, 'success');
                      }else{
                          self.$swal('',data.message,'info');
                      }
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      if (jqXHR.status == 0) {
                          self.errorMsg = "Remote server cannot be reached";
                      } else {
                          //redirect to login page if user not authenticated
                          if (jqXHR.status == 401) {
                              //clear previous data
                              localStorage.removeItem("user_obj");
                              localStorage.removeItem("tkn");
                              //EventBus.$emit("logged-in", true, "", "");
                              self.$router.push("/");
                          }
                          self.error = jqXHR.responseJSON.message;
                      }
                  }
              });

            },
            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
            rebillVariable:function(){
                var self = this;

                self.fetchBilledVariableRates();
            },
            fetchBilledVariableRates:function(){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/billed-variable",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        id: segments[3],
                        flag: "contract_asset"
                    },
                    success: function (data) {

                        self.loading = false;

                        if (data.status == "success") {

                            self.billedVariableArr = data.content;
                            self.activetab = 4;
                            self.rebill = true;
                        }else{
                            self.billedVariableArr = [];
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            cancelRebill:function(){
                var self = this;

                self.rabill = false;
                self.billedVariableArr = [];

            },
            postRebill:function(){
                var self  = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                var error = false;
                // var valueAdded = false;
                var alertOccured = false;
                if (self.billedVariableArr && self.billedVariableArr.length > 0){
                    for (var i=0; i<self.billedVariableArr.length; i++) {
                        if (self.billedVariableArr[i].new_reading == '' || self.billedVariableArr[i].new_reading == 0){
                            self.billedVariableArr[i].new_reading_error_msg = 'Reading Required';
                            error = true;
                        }else{
                            // valueAdded = true;
                            self.billedVariableArr[i].new_reading_error_msg = '';
                        }
                        if (parseInt(self.billedVariableArr[i].new_reading) < parseInt(self.billedVariableArr[i].reading_in)){
                            if(alertOccured == false){
                                if (confirm('New Reading in less than previous reading')) {
                                    alertOccured = true;
                                }else{
                                    error = true;
                                }
                            }

                        }
                        for (var j=0; j<self.unitArr.length; j++){
                            if (self.unitArr[j].sectionName.toLowerCase() == self.billedVariableArr[i].section.toLowerCase()){
                                if (self.billedVariableArr[i].new_reading != '' && parseInt(self.billedVariableArr[i].new_reading) <= parseInt(self.unitArr[j].reading_out)){
                                    self.billedVariableArr[i].new_reading_error_msg = 'New Reading Should be greater than reading out.';
                                    error = true;
                                }
                            }
                        }
                    }
                }else{
                    self.$swal('','No invoice found for variable rates','info');
                    return;
                }

                if (!error){

                    $.ajax({
                        url: process.env.ROOT_API + "/post-rebill",
                        type: "POST",
                        headers: this.ajxHeaders,
                        dataType: "json",
                        data:{
                            id: segments[3],
                            readingArr: JSON.stringify(self.billedVariableArr),
                            flag:'contract_asset'
                        },
                        success: function (data) {

                            self.loading = false;

                            if (data.status == "success") {
                                if (data.content.id){
                                    self.$router.push('/lease-contract/invoice/'+data.content.id);
                                }else{

                                }
                            }else{

                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }

            },
            billingRecords() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/billing-records",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        id: segments[3],
                        flag: "contract_asset"
                    },
                    success: function (data) {

                        self.loading = false;

                        if (data.status == "success") {

                            self.billingRecordsArr = data.content;
                        }else{
                            self.billingRecordsArr = [];
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            addAllowance() {
                var self = this;
                self.addUpdateAllowance = true;
                self.rows = [];
                self.rows.push({
                    contract_allowance_id:0,
                    allowance_type:null,
                    allowance_type_error_msg:"",
                    allowance_amount: "",
                    allowance_amount_error_msg:"",
                    remaining_amount:0,
                    disabled:false,
                    disableUpdate:false
                });
            },
            addRow() {
                var self = this;
                var index = self.rows.length - 1;
                self.rows[index].allowance_type_error_msg = "";
                self.rows[index].allowance_amount_error_msg = "";

                if ((self.rows[index].allowance_type != null && self.rows[index].allowance_type.value) && (self.rows[index].allowance_amount != null && self.rows[index].allowance_amount != "" && self.rows[index].allowance_amount)) {

                    var typeArr = [];
                    var found = false;
                    if (self.rows.length > 1) {
                        for (var i = 0;i < self.rows.length;i++) {
                            if (self.rows[i].allowance_type != null) {
                                typeArr.push(self.rows[i].allowance_type.value);
                            }
                        }
                        //check all values in array are equal or not
                        found = self.hasDuplicates(typeArr);
                    }

                    if (found) {
                        self.rows[index].allowance_type_error_msg = "Type Already Added.";
                    }else{
                        self.rows.push({
                            contract_allowance_id:0,
                            allowance_type:null,
                            allowance_type_error_msg:"",
                            allowance_amount: "",
                            allowance_amount_error_msg:"",
                            remaining_amount:0,
                            disabled:false,
                            disableUpdate:false
                        });
                    }

                }else{

                    if (self.rows[index].allowance_type == null || !self.rows[index].allowance_type.value) {
                        self.rows[index].allowance_type_error_msg = "Type Required.";
                    }

                    if (self.rows[index].allowance_amount == null || self.rows[index].allowance_amount == "" || !self.rows[index].allowance_amount) {
                        self.rows[index].allowance_amount_error_msg = "Allowance Amount Required.";
                    }
                }
            },
            removeAllowance(index) {
                var self = this;
                var currentIndex = index;
                if (self.rows.length >= 1) {
                    if (self.rows[index].contract_allowance_id == 0) {
                        self.rows.splice(index, 1);
                    } else {
                        //allowance already in use then not allow to remove allowance
                        if (self.rows[index].disableUpdate) {
                            self.$swal('',"Allowance already in use.",'info');
                            return;
                        }

                        if (confirm('Are you sure that you want to remove this allowance? ')) {

                            self.loading = true;
                            $.ajax({
                                url: process.env.ROOT_API + "/contractallowance/delete",
                                type: "POST",
                                data: {'id': self.rows[index].contract_allowance_id},
                                headers: this.ajxHeaders,
                                dataType: "json",
                                success: function (data) {
                                    if (data.status == "success") {

                                        setTimeout(function () {
                                            self.contractAllowanceList();
                                            self.rows.splice(currentIndex, 1);
                                        },50);

                                    }
                                },
                                error: function (jqXHR, exception) {
                                    self.generateStatusCodeMessage(jqXHR,true,'journal-item-delete')
                                },
                            });
                        }

                    }
                }
            },
            createContractAssetReading:function(from){
                var self = this;

                var error = false;
                self.expiry_date_error_msg = "";

                if(from != 'final' && from != 'error'){
                    if (self.returnFlag == true){
                        if (new Date(self.effDate) > new Date(self.expiry_date)){
                            self.$swal('','Termination date is less then start date of contract','info');
                            error = true;
                            return;
                        }
                        if (moment().format("MM/DD/YYYY") > self.expiry_date){
                            // // self.$swal('','Please update expiry date to current date first','info');
                            // self.expiry_date_error_msg = "Expiry date should be same as current date";
                            // error = true;
                            if (confirm('Termination date is less then current date Are you sure to return? ')) {

                            }else{
                                error = true;
                            }
                        }
                        if (moment().format("MM/DD/YYYY") < self.expiry_date){
                            // // self.$swal('','Please update expiry date to current date first','info');
                            // self.expiry_date_error_msg = "Expiry date should be same as current date";
                            // error = true;
                            if (confirm('Termination date is greater then current date Are you sure to return? ')) {

                            }else{
                                error = true;
                            }
                        }



                        if (self.readInArr && self.readInArr.length > 0){
                            for (var i=0; i<self.readInArr.length; i++) {
                                if (self.contractAssetData.contract_type && (self.contractAssetData.ctCode != 'M2' && self.contractAssetData.ctCode != 'M3')){
                                    if (self.readInArr[i].reading_in == '' || self.readInArr[i].reading_in == 0){
                                        self.readInArr[i].reading_in_error_msg = 'Reading In Required';
                                        error = true;
                                    }else{
                                        self.readInArr[i].reading_in_error_msg = '';
                                    }
                                    if (self.readInArr[i].reading_in_date == '' || self.readInArr[i].reading_in_date == null){
                                        self.readInArr[i].reading_in_date_error_msg = 'Reading Date Required';
                                        error = true;
                                    }else{
                                        self.readInArr[i].reading_in_date_error_msg = "";
                                    }

                                    for (var j=0; j<self.unitArr.length; j++){
                                        if (self.unitArr[j].section_id.value == self.readInArr[i].section_id){
                                            if (new Date(self.readInArr[i].reading_in_date) != '' && new Date(self.readInArr[i].reading_in_date) <= new Date(self.unitArr[j].reading_out_date)){
                                                self.readInArr[i].reading_in_date_error_msg = 'Reading Date Should be greater than reading out date.';
                                                error = true;
                                            }
                                            if (self.readInArr[i].reading_in != '' && parseInt(self.readInArr[i].reading_in) < parseInt(self.unitArr[j].reading_out)){
                                                //as discussed to handle meter change
                                                // self.readInArr[i].reading_in_error_msg = 'Reading In Should be greater than reading out.';
                                                // error = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        if (self.unitArr && self.unitArr.length > 0){
                            for (var i=0; i<self.unitArr.length; i++) {
                                if (self.unitArr[i].section_id == null || !self.unitArr[i].section_id.value){
                                    self.unitArr[i].section_error_msg = 'Section Required';
                                    error = true;
                                }else{
                                    self.unitArr[i].section_error_msg = '';
                                }
                                if (self.contractAssetData.contract_type && (self.contractAssetData.ctCode != 'M2' && self.contractAssetData.ctCode != 'M3') ){
                                    if (self.unitArr[i].reading_out == '' ){
                                        self.unitArr[i].reading_out_error_msg = 'Reading Out Required';
                                        error = true;
                                    }else{
                                        self.unitArr[i].reading_out_error_msg = '';
                                    }
                                    if (self.unitArr[i].reading_out_date == '' || self.unitArr[i].reading_out_date == null){
                                        self.unitArr[i].reading_out_date_error_msg = 'Reading Date Required';
                                        error = true;
                                    }else{
                                        self.unitArr[i].reading_out_date_error_msg = "";
                                    }
                                }
                                if (self.contractAssetData.ctCode && self.contractAssetData.ctCode != 'M3'){
                                    // if (self.unitArr[i].estimate == '' || self.unitArr[i].estimate == null){
                                    //     self.unitArr[i].estimate_error_msg = 'Estimate Unit Required';
                                    //     error = true;
                                    // }else{
                                    //     self.unitArr[i].estimate_error_msg = "";
                                    // }
                                    // if (self.unitArr[i].free_reading == '' || self.unitArr[i].free_reading == null){
                                    //     self.unitArr[i].free_reading_error_msg = 'Free Reading Required';
                                    //     error = true;
                                    // }else{
                                    //     self.unitArr[i].free_reading_error_msg = "";
                                    // }
                                }
                            }
                        }

                    }else{
                        if (self.unitArr && self.unitArr.length > 0){
                            for (var i=0; i<self.unitArr.length; i++) {
                                    if (self.unitArr[i].section_id == null || !self.unitArr[i].section_id.value){
                                    self.unitArr[i].section_error_msg = 'Section Required';
                                    error = true;
                                }else{
                                    self.unitArr[i].section_error_msg = '';
                                }
                                if (self.contractAssetData.contract_type && (self.contractAssetData.ctCode != 'M2' && self.contractAssetData.ctCode != 'M3')){
                                    if (self.unitArr[i].reading_out == '' || self.unitArr[i].reading_out == 0){
                                        self.unitArr[i].reading_out_error_msg = 'Reading Out Required';
                                        error = true;
                                    }else{
                                        self.unitArr[i].reading_out_error_msg = '';
                                    }
                                    if (self.unitArr[i].reading_out_date == '' || self.unitArr[i].reading_out_date == null){
                                        self.unitArr[i].reading_out_date_error_msg = 'Reading Date Required';
                                        error = true;
                                    }else{
                                        self.unitArr[i].reading_out_date_error_msg = "";
                                    }
                                    if (self.contractAssetData.contract_type && (self.contractAssetData.ctCode != 'M3' && self.contractAssetData.ctCode != 'M2')){
                                        if (self.unitArr[i].estimate == '' || self.unitArr[i].estimate == null){
                                            self.unitArr[i].estimate_error_msg = 'Estimate Unit Required';
                                            error = true;
                                        }else{
                                            self.unitArr[i].estimate_error_msg = "";
                                        }

                                        // if (self.unitArr[i].free_reading == '' || self.unitArr[i].free_reading == null){
                                        //     self.unitArr[i].free_reading_error_msg = 'Free Reading Required';
                                        //     error = true;
                                        // }else{
                                        //     self.unitArr[i].free_reading_error_msg = "";
                                        // }
                                    }
                                }
                            }
                        }
                    }
                }

                if (!error) {

                        if (from == 'return'){
                            self.$refs.misc_charges_module.createMiscCharge('return');
                            return;
                        }
                        if (from == 'error'){
                            self.$swal('','Charges not stored','info');
                            return;
                        }

                        var path = window.location.pathname;
                        var segments = path.split("/");


                       var fields = [];

                        fields.push({name: "id", value: segments[3]});

                        if (self.returnFlag == true || self.closed == 1){

                            fields.push({name: "reading_in", value: JSON.stringify(self.readInArr)});
                            // fields.push({name: "effective_date", value: self.effective_date});
                            fields.push({name: "expiry_date", value: self.expiry_date});
                            fields.push({name: "actual_return_date", value: self.expiry_date});

                        }
                        fields.push({name: "reading_out", value: JSON.stringify(self.unitArr)});

                        fields.push({name: "id", value: segments[3]});
                        fields.push({name:"vmUnitNo",value: self.contractAssetData.vmUnitNo});
                        fields.push({name:"vehicle_pool_id",value: self.vehicle_pool_id.value});
                        fields.push({name:"vehicle_pool_date",value: self.expiry_date});
                        console.log(fields);//return;
                        self.loading = true;

                        $.ajax({
                            url: process.env.ROOT_API + "/contractassetdetail-reading/create",
                            type: "POST",
                            data: fields,
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                self.loading = false;

                                if (data.status == "success") {
                                    self.onlyList = true;
                                    self.loadContract();
                                    if (data.old_expiry){
                                        localStorage.setItem('old_expiry',data.old_expiry);
                                        self.old_expiry = data.old_expiry;
                                    }
                                    $(".alert-contract").empty();
                                    $(".alert-contract").removeClass("show");
                                    $(".alert-contract").addClass("hide");

                                } else {
                                    if (data.content.length > 0) {
                                        var err = "<ul>";
                                        $(".alert-contract").empty();

                                        for (var i = 0; i < data.content.length; i++) {
                                            err += "<li>" + data.content[i] + "</li>";
                                        }
                                        err += "</ul>";
                                        $(".alert-contract").append(err);
                                        $(".alert-contract").addClass("show");

                                    }
                                }
                                if (self.returnFlag == true){
                                    self.$root.$emit("returned",'true');
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.loading = false;
                                self.generateStatusCodeMessage(jqXHR,true,'contract-asset-detail-create')
                            }
                        });
                }
            },
            //add or update contract allowance
            createAllowance() {
                var self = this;
                var error = false;
                var index = self.rows.length - 1;
                var typesArr = [];

                for (var i = 0;i < self.rows.length;i++) {

                    self.rows[i].allowance_type_error_msg = "";
                    self.rows[i].allowance_amount_error_msg = "";

                    if (self.rows[i].allowance_type == null || !self.rows[i].allowance_type.value) {
                        self.rows[i].allowance_type_error_msg = "Type Required.";
                        error = true;
                    }else{
                        typesArr.push(self.rows[i].allowance_type.value);
                    }

                    if (self.rows[i].allowance_amount == null || self.rows[i].allowance_amount == "" || !self.rows[i].allowance_amount) {
                        self.rows[i].allowance_amount_error_msg = "Allowance Amount Required.";
                        error = true;
                    }
                }

                if (typesArr.length > 1) {

                    if (self.hasDuplicates(typesArr)) {
                        self.rows[index].allowance_type_error_msg = "Type Already Added.";
                        error = true;
                    }

                }

                if (!error) {

                    self.loading = true;
                    var path = window.location.pathname;
                    var segments = path.split("/");

                    if (self.allowancesArr.length == 0) {

                        $("#CreateAllowanceBtn").val("Saving ...");
                        $("#CreateAllowanceBtn").prop("disabled", true);
                        $("#CancelAllowanceBtn").prop("disabled",true);

                    } else {

                        $("#CreateAllowanceBtn").val("Updating ...");
                        $("#CreateAllowanceBtn").prop("disabled", true);
                        $("#CancelAllowanceBtn").prop("disabled",true);

                    }

                    var fields = $("#allowanceForm").serializeArray();
                    fields.push({name: "allowanceItems", value: JSON.stringify(self.rows)});
                    fields.push({ name: "id", value: segments[3] });

                    $.ajax({
                        url: process.env.ROOT_API + "/contractallowance/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {

                            self.loading = false;
                            if (self.allowancesArr.length == 0) {

                                $("#CreateAllowanceBtn").val("Save");
                                $("#CreateAllowanceBtn").prop("disabled", false);
                                $("#CancelAllowanceBtn").prop("disabled",false);

                            } else {

                                $("#CreateAllowanceBtn").val("Update");
                                $("#CreateAllowanceBtn").prop("disabled", false);
                                $("#CancelAllowanceBtn").prop("disabled",false);

                            }

                            if (data.status == "success") {

                                self.addUpdateAllowance = false;
                                self.contractAllowanceList();
                            } else {

                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (self.allowancesArr.length == 0) {

                                $("#CreateAllowanceBtn").val("Save");
                                $("#CreateAllowanceBtn").prop("disabled", false);
                                $("#CancelAllowanceBtn").prop("disabled",false);

                            } else {

                                $("#CreateAllowanceBtn").val("Update");
                                $("#CreateAllowanceBtn").prop("disabled", false);
                                $("#CancelAllowanceBtn").prop("disabled",false);

                            }
                            self.generateStatusCodeMessage(jqXHR,false,'allowance-create')
                        }
                    });
                }

            },
            backAllowanceList() {
                var self = this;
                self.addUpdateAllowance = false;
            },
            contractAllowanceList() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/contractallowance/list",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        id: segments[3]
                    },
                    success: function (data) {

                        self.loading = false;

                        if (data.status == "success") {

                            self.allowancesArr = data.content;
                        }else{
                            self.allowancesArr = [];
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            editAllowance() {
                var self = this;
                self.addUpdateAllowance = true;
                self.rows = [];
                if (self.allowancesArr.length > 0) {
                    for(var i = 0;i< self.allowancesArr.length;i++) {
                        self.rows.push({
                            contract_allowance_id:self.allowancesArr[i].contract_allowance_id,
                            allowance_type:{text:self.allowancesArr[i].allowance_type_desc,value:self.allowancesArr[i].allowance_type_code},
                            allowance_type_error_msg:"",
                            allowance_amount: self.allowancesArr[i].allowance_amount,
                            allowance_amount_error_msg:"",
                            remaining_amount:self.allowancesArr[i].remaining_amount,
                            disabled:true,
                            disableUpdate:(self.allowancesArr[i].remaining_amount >0)?true:false
                        });
                    }
                }else{
                    self.rows.push({
                        contract_allowance_id:0,
                        allowance_type:null,
                        allowance_type_error_msg:"",
                        allowance_amount: "",
                        allowance_amount_error_msg:"",
                        remaining_amount:0,
                        disabled:false,
                        disableUpdate:false
                    });
                }
            },
            hasDuplicates(arr) {
	            return new Set(arr).size !== arr.length;
            },

            afterComplete(file,response){
                var self = this;

            },
            storeDocument(file,response){
                var self = this;
                self.doc_error_msg = "";
                // var uploadResponse = JSON.parse(response);
                var uploadResponse = response;

                //push doc path in files array
                self.files.push(uploadResponse.content);
                if (file.type != undefined) {
                    var extension = file.type.split("/");
                    self.validateDocs.push({
                        file_name:file.name,
                        size:file.size,
                        extension:extension[1]
                    });
                }
            },
            removedSelectedFile(file, xhr, error) {
                var self = this;
                self.insurance_doc_error_msg = "";

                if (file.xhr != undefined) {
                    var fileName = JSON.parse(file.xhr.response).content;

                    var fileArr = fileName.split("/");

                    self.removeFileFromServer(fileArr[1],"temp");

                    for(var i = 0;i<self.files.length;i++){
                        if ( self.files[i].includes(fileName)) {
                            self.files.splice(i,1);
                            self.validateDocs.splice(i,1);
                        }
                    }
                }

                console.log(self.files);

            },
            removeFileFromServer(file,flag){

                var self = this;
                var conAssetId = self.$route.params.id;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/remove-contract-insurance-doc",
                    type: "POST",
                    data: {
                        filePath : file,
                        id: conAssetId,
                        flag:flag
                    },
                    headers: self.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'remove-insurance-doc')
                    }
                });

            },
            getCustomerInvoice(){
                var self = this;
                self.activetab = 10;
                self.customerInvoiceLoad = true;
                // if(!self.tabMenuArray.includes(self.activetab)){
                    // self.tabMenuArray.push(self.activetab);
                // }
            },
            storeInsuranceDoc() {
                var self = this;
                var error = false;

                self.doc_error_msg = "";
                var physicalCheck = 0;
                var liabilityCheck = 0;
                var both = 0;

                if (self.insPolicyArr.length > 0) {

                    var errorMsg = "";
                    // if (self.policy_type.value == "physical") {

                        for(var i=0;i<self.insPolicyArr.length;i++) {
                            //check if physical found
                            if (self.insPolicyArr[i].policy_type != undefined && self.insPolicyArr[i].policy_type != null) {
                                if (self.insPolicyArr[i].policy_type.toLowerCase() == "physical") {
                                    physicalCheck = 1;
                                }
                            }

                            if (self.insPolicyArr[i] != undefined) {

                                if (self.insPolicyArr[i].policy_type.toLowerCase() == "liability") {
                                    liabilityCheck = 1;
                                }
                            }
                            if (self.insPolicyArr[i] != undefined) {

                                if (self.insPolicyArr[i].policy_type.toLowerCase() == "both") {
                                    both = 1;
                                }
                            }

                        }

                        // console.log("liabilityCheck :: " + liabilityCheck + " physicalCheck :: " + physicalCheck);

                        // for(var i=0;i<self.insPolicyArr.length;i++) {

                        //     if (self.insPolicyArr[i] != undefined) {

                        //         if (liabilityCheck == 1) {
                        //             if (self.insPolicyArr[i].policy_type == "liability") {

                        //             }
                        //         }
                        //     }

                        // }

                        if (physicalCheck == 0 && liabilityCheck == 1 && both == 0) {
                            //physical required
                            errorMsg = "Policy with Type Physical Required.";
                            self.common_error_msg = errorMsg;
                            error = true;
                        }else if (physicalCheck == 1 && liabilityCheck == 0 && both == 0) {
                            //liability required
                            errorMsg = "Policy with Type Liability Required.";
                            self.common_error_msg = errorMsg;
                            error = true;
                        }else if (physicalCheck == 1 && liabilityCheck == 1 && both == 1){
                            errorMsg = "Please select either both or Physical and Liability Policy.";
                            self.common_error_msg = errorMsg;
                            error = true;
                        }else if (both == 1 && (liabilityCheck == 1 || physicalCheck == 1)){
                            errorMsg = "Please select either both or Physical and Liability Policy.";
                            self.common_error_msg = errorMsg;
                            error = true;
                        }

                }else{
                    self.common_error_msg = 'Please select policy';
                    return;
                }
                // if (self.files.length > 0) {
                //     if (self.validateDocs.length > 0) {
                //         for (var i = 0;i < self.validateDocs.length;i++) {
                //             let fileObj = self.validateDocs[i];

                //             if (fileObj.extension != undefined) {
                //                 if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf" || fileObj.extension == "doc" || fileObj.extension == "docx") {

                //                 }else{
                //                     self.doc_error_msg = "Only Images or PDF or Doc Files Are Allowed (.jpg / .jpeg / .png / .pdf / .doc / .docx).";
                //                     error = true;
                //                 }
                //             }

                //             if (fileObj.size != undefined) {
                //                 if(fileObj.size > 5000000){
                //                     self.doc_error_msg = "File Size Should Not Be Greater Than 5 MB.";
                //                     error = true;
                //                 }
                //             }
                //         }
                //     }
                // }else{
                //     self.doc_error_msg = 'No file selected';
                //     return;
                // }
                if (error){
                    return;
                }
                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[3])
                {
                    $("#uploadInsuranceDoc").val("Saving ...");
                    $("#uploadInsuranceDoc").prop("disabled", true);

                }

                var fields = [];

                // if(self.files.length > 0){
                //     fields.push({name: "doc_path", value: JSON.stringify(self.files)});
                // }else{
                //     fields.push({name: "doc_path", value: null});
                // }
                fields.push({name: "id", value: segments[3]});

                var idArr = []; //insurance policy id array
                for (var i = 0;i < self.insPolicyArr.length;i++) {
                    idArr.push(self.insPolicyArr[i].insurance_policy_id);
                }
                fields.push({ name: "insurance_policies", value:JSON.stringify(idArr)});

                $.ajax({
                    url: process.env.ROOT_API + "/insurance-doc/upload",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (segments[3])
                        {
                            $("#uploadInsuranceDoc").val("Save");
                            $("#uploadInsuranceDoc").prop("disabled", false);
                        }
                        // self.validateDocs = [];
                        // self.files = [];
                        // self.removeAllFiles();
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }else{
                            self.$swal('',data.message,'success');
                        }
                        self.fetchInsurancePolicy();
                        self.loadContract();

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                            if (segments[3])
                            {
                                $("#uploadInsuranceDoc").val("Save");
                                $("#uploadInsuranceDoc").prop("disabled", false);
                            };
                        self.generateStatusCodeMessage(jqXHR,true,'insurance-doc-upload')
                    }
                });
            },
            removeAllFiles() {
                var self = this;
                self.$refs.insuredDropzone.removeAllFiles();
            },
            //load files in drop zone
            loadFilesPreview:function() {
                var self = this;
                if ( self.dropZonePreviewFiles.length > 0 ) {

                    for ( var i = 0;i<self.dropZonePreviewFiles.length;i++ ) {

                        var file = { size: self.dropZonePreviewFiles[i].size, name: self.dropZonePreviewFiles[i].file_name, type: self.dropZonePreviewFiles[i].file_type};
                        var url = self.dropZonePreviewFiles[i].url;
                        //get file path from url
                        self.files.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
                        //self.$refs.dropzone.manuallyAddFile(file, url);
                        self.validateDocs.push({
                            file_name:self.dropZonePreviewFiles[i].file_name,
                            extension:self.dropZonePreviewFiles[i].extension
                        });
                    }
                }
            },
            getFilePathFromUrl (value) {

                var path = "";
                var src = value.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2];
                path = orgPath + "/" + file_name;
                return path;

            },
            removeServerFile(fileName,key) {

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                var conAssetId = 0;
                if ( segments[3] != undefined ) {
                    conAssetId = segments[3];
                }

                if (confirm('Are you sure that you want to remove file? ')) {
                    self.removeFileFromServer(fileName,"server");
                    self.dropZonePreviewFiles.splice(key,1);

                    //remove file from files array
                    for ( var i = 0;i<self.files.length;i++ ) {
                        if ( self.files[i].includes(fileName)) {
                            self.files.splice(i,1);
                            self.validateDocs.splice(i,1);
                        }
                    }
                }

            },
            checkTriggers:function(flag){
                var self = this;
                if (flag == 'no_action'){
                    $("#trigger-message-modal").modal("hide");
                    return;
                }
                if (flag != 'no_program'){
                    var miles = 0;
                    var date = self.contractAssetData.effective_date;
                    if (self.unitArr && self.unitArr.length > 0){
                        for (var i=0; i<self.unitArr.length; i++) {
                            if (self.unitArr[i].section && self.unitArr[i].section == 'DIST'){
                                miles = self.unitArr[i].reading_out;
                                date = self.unitArr[i].reading_out_date;
                            }
                        }
                    }
                    self.$refs.triggerEnable.getMappedProgram(self.vehicle_id,miles,date);

                    return;
                }else{
                    $("#trigger-message-modal").modal("hide");

                    if (self.residual && self.residual > 0){
                        self.$swal({
                            title: '',
                            text: 'Residual found. Do you want to create depreciation for this asset ?',
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                            showCloseButton: true,
                            showLoaderOnConfirm: true
                        }).then((result) => {
                            if (result.value) {
                                self.processConAsset('yes');
                            } else {
                                self.processConAsset('no');
                            }
                        });
                    }else{
                        self.processConAsset('no');
                    }
                }
            },
            processConAsset:function(depCreate){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                $.ajax({
                    url: process.env.ROOT_API + "/contract-asset/process",
                    type: "POST",
                    headers: self.ajxHeaders,
                    data:{
                        con_asset_id:segments[3],
                        dep_create:depCreate
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        console.log("info === ", data);

                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                        }else{
                            if (data.status == 'dep_created'){
                                self.$swal({
                                    title: 'Processed Successfully.',
                                    text: 'Depreciation already created.',
                                    type: 'success',
                                })
                                self.loadContract();
                            }else{
                                self.$swal('',data.message,'info');
                                self.loadContract();
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'process-contract-asset');
                    }
                });
            },
            addLineItem: function () {
              console.log('here 1')

                var self = this;
                var i = self.unitArr.length - 1;
                var error = false;
                if (self.unitArr.length < 1){
                    self.unitArr.push({
                        section_id:null,
                        section_error_msg:'',
                        reading_out:'',
                        reading_out_error_msg:'',
                        reading_out_date:'',
                        reading_out_date_error_msg:'',
                        estimate_error_msg:'',
                        estimate:'',
                        estimate2:'',
                        ref_miles:'',
                        ref_reading_date:'',
                        add_line:'line',
                        sectionName:'',
                        free_reading:'',
                        free_reading_error_msg:'',
                        showDiv:true
                    });
                }else{
                    self.unitArr[i].section_error_msg = "";
                    self.unitArr[i].reading_out_error_msg = "";
                    self.unitArr[i].reading_out_date_error_msg = "";
                    self.unitArr[i].estimate_error_msg = "";

                    if (self.unitArr[i].section_id != null && self.unitArr[i].section_id != '' && self.unitArr[i].section_id.value &&
                        self.unitArr[i].reading_out != '' && self.unitArr[i].reading_out != null && self.unitArr[i].reading_out_date != null &&
                        self.unitArr[i].reading_out_date != '' && ((self.contractAssetData.ctCode == 'M3' || self.contractAssetData.ctCode == 'M2') || (self.unitArr[i].estimate != null && self.unitArr[i].estimate != ''))) {
                            self.unitArr.push({
                                section_id:null,
                                section_error_msg:'',
                                reading_out:'',
                                reading_out_error_msg:'',
                                reading_out_date:'',
                                reading_out_date_error_msg:'',
                                estimate_error_msg:'',
                                estimate:'',
                                estimate2:'',
                                ref_miles:'',
                                ref_reading_date:'',
                                add_line:'line',
                                sectionName:'',
                                free_reading:'',
                                free_reading_error_msg:'',
                                showDiv:true
                            });

                    } else {
                        if (self.unitArr[i].section_id == null || self.unitArr[i].section_id == '' || !self.unitArr[i].section_id) {
                            self.unitArr[i].section_error_msg = "Section is Required.";
                            error = true;
                        }

                        if (self.unitArr[i].reading_out == '' || self.unitArr[i].reading_out == 0){
                            self.unitArr[i].reading_out_error_msg = 'Reading Out Required';
                            error = true;
                        }else{
                            self.unitArr[i].reading_out_error_msg = '';
                        }
                        if (self.unitArr[i].reading_out_date == '' || self.unitArr[i].reading_out_date == null){
                            self.unitArr[i].reading_out_date_error_msg = 'Reading Date Required';
                            error = true;
                        }else{
                            self.unitArr[i].reading_out_date_error_msg = "";
                        }
                        // if (self.unitArr[i].estimate == '' || self.unitArr[i].estimate == null){
                        //     self.unitArr[i].estimate_error_msg = 'Estimate Unit Required';
                        //     error = true;
                        // }else{
                        //     self.unitArr[i].estimate_error_msg = "";
                        // }
                        // if (self.unitArr[i].free_reading == '' || self.unitArr[i].free_reading == null){
                        //     self.unitArr[i].free_reading_error_msg = 'Free Reading Required';
                        //     error = true;
                        // }else{
                        //     self.unitArr[i].free_reading_error_msg = "";
                        // }
                    }
                }

            },
            removeElement: function (index) {
                var self = this;
                if (self.unitArr.length > 1) {
                    self.unitArr.splice(index, 1);
                }
            },
            getSectionTypes(){

                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/contracttype/getsectionrate",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        type:'variable',
                        flag:'without_penalty'
                    },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {

                            self.sectionTypes = data.content;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'contract-asset-get-section-rate')
                    }
                });
            },
            fetchBilling:function(from){
                var self = this;

                var path = window.location.pathname;
                var segments = path.split("/");

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/return-billing/fetch",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        id: segments[3],
                        flag: "contract",
                        inv_for:from
                    },
                    success: function (data) {

                        self.loading = false;
                        self.billingLoaded = true;

                        if (data.status == "success") {
                            self.amountFound = false;
                            self.billingArr = data.content;

                             if (self.billingArr.length > 0){
                                for (var i=0;i<self.billingArr.length;i++){
                                    if (self.billingArr[i].billed_days != 0){
                                        self.amountFound = true;
                                    }
                                }
                            }
                        }else{
                            self.billingArr = [];
                            self.amountFound = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            closeContract:function(){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/contract-asset/close",
                    type: "POST",
                    data: {
                        con_asset_id:segments[3],
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $("#postInvoiceModal").modal("hide");
                        if (data.status == "success") {

                            if(self.contractAssetData.ctCode == "M1" || self.contractAssetData.ctCode == "M3") {
                                setTimeout(function () {
                                self.$swal({
                                    title: '',
                                    text: 'Do you want to Void this Unit',
                                    type: 'info',
                                    showCancelButton: true,
                                    confirmButtonText: 'Yes',
                                    cancelButtonText: 'No',
                                    showCloseButton: true,
                                    showLoaderOnConfirm: true
                                }).then((result) => {
                                    if (result.value) {
                                        // API CALL
                                        self.voidAssetStatus();
                                    } else {
                                    }
                                    self.applyMultipleTermination();
                                });
                                }, 1000);
                                    if (self.$route.query.batch != undefined && self.$route.query.batch != ''){
                                  }else{
                                    self.loadContract();
                                  }
                            } else {
                                 if (self.$route.query.batch != undefined && self.$route.query.batch != ''){
                                  }else{
                                    self.loadContract();
                                    setTimeout(function () {
                                    self.applyMultipleTermination();
                                    }, 1000);
                                  }
                            }
                            if (self.$route.query.batch != undefined && self.$route.query.batch != ''){
                                var path = window.location.pathname;
                                var segments = path.split("/");
                                var oldExp = '';
                                if (localStorage.getItem('old_expiry') != undefined){
                                    oldExp = localStorage.getItem('old_expiry');
                                    localStorage.removeItem('old_expiry');
                                }
                                setTimeout(function () {
                                    self.$router.push('/contractassetdetail/add?batch='+self.$route.query.batch+'&&id='+segments[3]+'&&old_expiry='+oldExp);
                                }, 1000);
                                return;
                            }
                        }else{
                            self.loadContract();
                        }
                    },
                    error: function (jqXHR, exception) {
                        $("#postInvoiceModal").modal("hide");
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            getActivityLog(){
              var self = this;
              self.activetab = 11;
              var path = window.location.pathname;
              var segments = path.split("/");
              if(!self.tabMenuArray.includes(self.activetab)){

                this.$root.$emit('activity_log_opted','contract',segments[3]);
                self.activityLogsTabValue = "loadList";   // flag value set to loadList so that filters in list work properly.

              }
            },
            fetchInsurancePolicy() {
                var self = this;
                var error = false;
                var path = window.location.pathname;
                var segments = path.split("/");
                // if (!error) {

                self.loading = true;

                var fields = {
                    customer_id:self.customer_id,
                    due_out_date:self.effDate,
                    due_in_date:self.expDate,
                    insurance_from_date:self.effDate,
                    insurance_to_date:self.expDate,
                    policy_type:'both',
                    vehicle_id:self.vehicle_id,
                    charge_update:0,
                    id:0,
                    contract_type_id:self.contract_type_id,
                    truck_type_id:self.truck_type_id,
                    is_national_lease:0,
                    is_future_rate_adj:false,
                    con_asset_id:segments[3]
                };

                $.ajax({
                    url: process.env.ROOT_API + "/fetch-insurance-policy-for-lease",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: fields,
                    crossDomain: true,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            //charge to dates are same for purchasing insurance yes
                            self.insurancePolicyArr = data.content.insurance_policy;
                            self.insPolicyArr = [];
                            setTimeout(function(){
                                if(self.insurancePolicyArr.length > 0){
                                    for(var l =0; l < self.insurancePolicyArr.length; l++){
                                        if (self.insurancePolicyArr[l].policy_added == 1){
                                            $("#selectCheckbox"+l).prop("checked", true); //check selected insurance policy
                                            if (self.insurancePolicyArr[l].status == 'Active'){
                                                self.insPolicyArr.push(self.insurancePolicyArr[l]);
                                            }
                                        }
                                    }
                                }
                            },1000);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-find-insurance-policy')
                    }
                });
                // }
            },
            policySelect(evt,row,index){
                var self = this;
                self.common_error_msg = "";
                if(evt.target.checked == true){
                    // if ( self.customerInsuredLabel == 1 ||self.customer_insured == 1) {
                        if (row != undefined) {
                            if (row.policy_type != undefined) {
                                if (self.insPolicyArr.length < 1) {
                                    self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                                }else{
                                    var alreadySelected = self.insPolicyArr[0].policy_type.toLowerCase(); //already selected policy

                                    if (alreadySelected == "both") {
                                        self.$swal('','You have already selected Policy with Type Both','info');
                                        evt.target.checked = false;
                                        return;
                                    }else if (alreadySelected == "physical") {

                                        if (row.policy_type.toLowerCase() == "physical" || row.policy_type.toLowerCase() == "both") {
                                            // policy with type physical already selected
                                            if (self.insPolicyArr.length == 1) {
                                                self.$swal('','You have selected Policy with Type Physical. Please select policy with type Liability','info');
                                                evt.target.checked = false;
                                                return;
                                            }else{
                                                self.$swal('','You have already selected Policy with Type Physical and Liability','info');
                                                evt.target.checked = false;
                                                return;
                                            }
                                        }else{
                                            if (self.insPolicyArr.length < 2 ) {
                                                self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                                            }else{
                                                self.$swal('','You have already selected Policy with Type Liability and Physical','info');
                                                evt.target.checked = false;
                                                return;
                                            }
                                        }
                                    }else if (alreadySelected == "liability") {
                                        if (row.policy_type.toLowerCase() == "liability" || row.policy_type.toLowerCase() == "both") {
                                            // policy with type liability already selected
                                            if (self.insPolicyArr.length == 1) {
                                                self.$swal('','You have selected Policy with Type Liability. Please select policy with type Physical','info');
                                                evt.target.checked = false;
                                                return;
                                            }else{
                                                self.$swal('','You have already selected Policy with Type Liability and Physical','info');
                                                evt.target.checked = false;
                                                return;
                                            }
                                        }else{
                                            if (self.insPolicyArr.length < 2 ) {
                                                self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                                            }else{
                                                self.$swal('','You have already selected Policy with Type Liability and Physical','info');
                                                evt.target.checked = false;
                                                return;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                }else{
                    var i = self.insPolicyArr.indexOf(row);
                    const filteredItems = self.insPolicyArr.filter(function(item) {
                        return item.insurance_policy_id !== row.id
                    })
                    self.insPolicyArr = filteredItems;
                }
            },
            removeBillElement:function(index){
                var self = this;

                if (index != undefined){
                    self.billingArr.splice(index,1);
                }
                if (!self.billingArr.length){
                    self.amountFound = false;
                }
            },
            changeQuantity:function(index){
                var self = this;
                var rt = 0;

                if (self.billingArr[index].billed_days != undefined){
                    rt = self.billingArr[index].billed_days * parseFloat(self.removeFormat(self.billingArr[index].rate,true));

                    self.billingArr[index].billed_amount = self.amountFormat(rt,5);
                }
            },
            editPurchaseOrderDropDown: function(){
              var self = this;
              self.editPurchaseOrder = false;
            },
            onSearchPO(search, loading) {
              var self = this;
              if(self.contract_id == null){

                self.contract_error_msg = 'Contract require to search PO';
              }else{

                self.contract_error_msg = "";
              }
              if (search.length > 0 && self.customer_id != null && self.customer_id != "") {
                // loading(true);
                self.searchPo(search,self.customer_id);
              }

            },
            cancelPurchaseOrderEdit: function(){
                var self = this;
                self.editPurchaseOrder = true;
                self.customer_po_error_msg = "";
            },
            searchPo(searchValue,custId){

              var self = this;
              console.log('I am here in the searchPO function')
              // self.loading = true;
              $.ajax({
                url: process.env.ROOT_API + "/cust-po/search",
                type: "POST",
                headers: this.ajxHeaders,
                data: {
                  customer_id:custId,
                  search:searchValue
                },
                dataType : "json",
                success: function (data) {
                  self.loading = false;
                  if (data.status == "success") {
                    self.poArr = data.content;
                  }
                },
                error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-search-po')
                }
              });
            },
          savePo: function(){
              var self = this;
              var path = window.location.pathname;
              var segments = path.split("/");
              self.loading = true;
              self.customer_po_error_msg = "";
              if (self.po != null && self.po.value){
                $.ajax({
                  url: process.env.ROOT_API + "/contractassetdetail/customer-po/update",
                  type: "POST",
                  headers: this.ajxHeaders,
                  data: {
                    contract_asset_id:segments[3],
                    customer_po:self.po.value
                  },
                  dataType : "json",
                  success: function (data) {
                    self.loading = false;
                    self.editPurchaseOrder = true;
                    if (data.status == "success") {
                      self.loadContract();
                    }
                  },
                  error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'update contract asset customer po')
                  }
                });
              }else{
                self.customer_po_error_msg = "PO value is required";
                self.loading = false;
              }
          },
          viewModule(module,id) {
                let self = this;
                let link = '/'+module+'/view/'+id;
                let routeData = self.$router.resolve(link);
                window.open(routeData.href, '_blank');
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/contract/ContractAssetView.vue